var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11To1Session(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227.299,
    height: 270.438,
    viewBox: "0 0 227.299 270.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25370",
    "data-name": "Rectangle 25370",
    width: 200.639,
    height: 180.438,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25369",
    "data-name": "Rectangle 25369",
    width: 200.638,
    height: 180.437,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25307",
    "data-name": "Rectangle 25307",
    width: 24.654,
    height: 21.457,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25308",
    "data-name": "Rectangle 25308",
    width: 19.131,
    height: 11.899,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25339",
    "data-name": "Rectangle 25339",
    width: 31.197,
    height: 29.452,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25340",
    "data-name": "Rectangle 25340",
    width: 26.732,
    height: 29.451,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25341",
    "data-name": "Rectangle 25341",
    width: 20.514,
    height: 36.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25342",
    "data-name": "Rectangle 25342",
    width: 6.18,
    height: 31.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25343",
    "data-name": "Rectangle 25343",
    width: 22.114,
    height: 33.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25344",
    "data-name": "Rectangle 25344",
    width: 5.621,
    height: 1.295,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25347",
    "data-name": "Rectangle 25347",
    width: 32.186,
    height: 72.016,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25351",
    "data-name": "Rectangle 25351",
    width: 90.993,
    height: 10.004,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25352",
    "data-name": "Rectangle 25352",
    width: 90.788,
    height: 0.244,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25355",
    "data-name": "Rectangle 25355",
    width: 4.33,
    height: 72.016,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25361",
    "data-name": "Rectangle 25361",
    width: 20.902,
    height: 22.409,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25362",
    "data-name": "Rectangle 25362",
    width: 17.95,
    height: 18.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25363",
    "data-name": "Rectangle 25363",
    width: 14.86,
    height: 14.289,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87916",
    "data-name": "Group 87916",
    transform: "translate(-13821 -19759)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4987",
    "data-name": "Ellipse 4987",
    cx: 113.649,
    cy: 113.649,
    r: 113.649,
    transform: "translate(13821 19759)",
    fill: "#e4f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87818",
    "data-name": "Group 87818",
    transform: "translate(13918 19781.494)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_24009",
    "data-name": "Rectangle 24009",
    width: 33.012,
    height: 42.341,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203106",
    "data-name": "Path 203106",
    d: "M14.7,2.96l.159.1c.269.777.608,2.013.957,3.319v.209l-.887.07Z",
    transform: "translate(-0.048 -0.01)",
    fill: "#ffa900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87502",
    "data-name": "Group 87502",
    transform: "translate(13835 19849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87501",
    "data-name": "Group 87501",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87500",
    "data-name": "Group 87500",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87499",
    "data-name": "Group 87499",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275647",
    "data-name": "Path 275647",
    d: "M103.7,14.551A14.551,14.551,0,1,1,89.149,0,14.551,14.551,0,0,1,103.7,14.551",
    transform: "translate(77.085 -0.001)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275648",
    "data-name": "Path 275648",
    d: "M103.021,14.371A13.884,13.884,0,1,1,89.138.487a13.884,13.884,0,0,1,13.884,13.884",
    transform: "translate(77.763 0.502)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275649",
    "data-name": "Path 275649",
    d: "M101.7,13.925A13.007,13.007,0,1,1,88.692.918,13.007,13.007,0,0,1,101.7,13.925",
    transform: "translate(78.208 0.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87453",
    "data-name": "Group 87453",
    transform: "translate(154.959 3.359)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87452",
    "data-name": "Group 87452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87451",
    "data-name": "Group 87451",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275650",
    "data-name": "Path 275650",
    d: "M100.863,10.407C94.94,14,85.2,19.882,79.763,23.111a13.043,13.043,0,0,1-3.554-4.78l18-16.677a13.021,13.021,0,0,1,6.657,8.754",
    transform: "translate(-76.209 -1.652)",
    fill: "#ececec"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87456",
    "data-name": "Group 87456",
    transform: "translate(160.767 15.328)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87455",
    "data-name": "Group 87455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87454",
    "data-name": "Group 87454",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275651",
    "data-name": "Path 275651",
    d: "M98.2,7.539a12.865,12.865,0,0,1-.86,4.227L81.115,19.438a12.993,12.993,0,0,1-2.05-.88c4.9-2.832,13.855-7.985,19.132-11.019",
    transform: "translate(-79.066 -7.538)",
    fill: "#ececec"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25309",
    "data-name": "Rectangle 25309",
    width: 0.252,
    height: 1.972,
    transform: "translate(166.775 2.81)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275652",
    "data-name": "Path 275652",
    d: "M80.048,3.98l-.986-1.708.218-.126.986,1.708Z",
    transform: "translate(81.698 2.217)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275653",
    "data-name": "Path 275653",
    d: "M78.621,5.5l-1.708-.986.126-.218,1.708.986Z",
    transform: "translate(79.477 4.438)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25310",
    "data-name": "Rectangle 25310",
    width: 1.972,
    height: 0.252,
    transform: "translate(154.837 14.748)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275654",
    "data-name": "Path 275654",
    d: "M77.039,10.947l-.126-.218,1.708-.986.126.218Z",
    transform: "translate(79.477 10.067)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275655",
    "data-name": "Path 275655",
    d: "M79.28,13.416l-.218-.126.986-1.708.218.126Z",
    transform: "translate(81.698 11.968)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25311",
    "data-name": "Rectangle 25311",
    width: 0.252,
    height: 1.972,
    transform: "translate(166.775 24.965)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275656",
    "data-name": "Path 275656",
    d: "M85.5,13.416l-.986-1.708.218-.126.986,1.708Z",
    transform: "translate(87.327 11.968)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275657",
    "data-name": "Path 275657",
    d: "M88.057,10.947l-1.708-.986.126-.218,1.708.986Z",
    transform: "translate(89.228 10.067)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25312",
    "data-name": "Rectangle 25312",
    width: 1.972,
    height: 0.252,
    transform: "translate(176.992 14.748)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275658",
    "data-name": "Path 275658",
    d: "M86.475,5.5l-.126-.218L88.057,4.3l.126.218Z",
    transform: "translate(89.228 4.438)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275659",
    "data-name": "Path 275659",
    d: "M84.728,3.98l-.218-.126L85.5,2.146l.218.126Z",
    transform: "translate(87.328 2.217)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275660",
    "data-name": "Path 275660",
    d: "M82.584,1.824l.427,12.048-1.232-.014.47-12.037Z",
    transform: "translate(84.505 1.88)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275661",
    "data-name": "Path 275661",
    d: "M90.284,5.4l-8.107,5.173L81.59,9.488,90.124,5.1Z",
    transform: "translate(84.31 5.273)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275662",
    "data-name": "Path 275662",
    d: "M82.717,7.529a.421.421,0,1,1-.421-.421.422.422,0,0,1,.421.421",
    transform: "translate(84.605 7.344)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25313",
    "data-name": "Rectangle 25313",
    width: 51.212,
    height: 3.04,
    transform: "translate(14.28 22.607)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25314",
    "data-name": "Rectangle 25314",
    width: 3.042,
    height: 10.057,
    transform: "translate(58.562 25.647)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25315",
    "data-name": "Rectangle 25315",
    width: 3.042,
    height: 3.109,
    transform: "translate(58.562 25.647)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25316",
    "data-name": "Rectangle 25316",
    width: 3.042,
    height: 10.057,
    transform: "translate(18.166 25.647)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25317",
    "data-name": "Rectangle 25317",
    width: 3.042,
    height: 3.109,
    transform: "translate(18.166 25.647)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25318",
    "data-name": "Rectangle 25318",
    width: 4.88,
    height: 19.38,
    transform: "translate(47.67 3.227)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25319",
    "data-name": "Rectangle 25319",
    width: 4.88,
    height: 2.129,
    transform: "translate(47.67 2.19)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25320",
    "data-name": "Rectangle 25320",
    width: 4.88,
    height: 0.791,
    transform: "translate(47.67 7.048)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25321",
    "data-name": "Rectangle 25321",
    width: 5.488,
    height: 2.129,
    transform: "translate(47.062 17.934)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25322",
    "data-name": "Rectangle 25322",
    width: 3.41,
    height: 22.607,
    transform: "translate(44.258)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25323",
    "data-name": "Rectangle 25323",
    width: 2.048,
    height: 8.695,
    transform: "translate(44.953 2.125)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25324",
    "data-name": "Rectangle 25324",
    width: 22.607,
    height: 3.41,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, 19.992, 20.184)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25325",
    "data-name": "Rectangle 25325",
    width: 8.695,
    height: 2.047,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, 24.237, 16.932)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25326",
    "data-name": "Rectangle 25326",
    width: 5.793,
    height: 17.172,
    transform: "translate(38.467 5.437)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25327",
    "data-name": "Rectangle 25327",
    width: 5.793,
    height: 1.6,
    transform: "translate(38.467 19.189)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25328",
    "data-name": "Rectangle 25328",
    width: 5.793,
    height: 0.62,
    transform: "translate(38.467 17.517)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25329",
    "data-name": "Rectangle 25329",
    width: 4.002,
    height: 16.139,
    transform: "translate(52.548 6.472)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25330",
    "data-name": "Rectangle 25330",
    width: 4.002,
    height: 1.505,
    transform: "translate(52.548 19.394)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25331",
    "data-name": "Rectangle 25331",
    width: 4.002,
    height: 1.505,
    transform: "translate(52.548 9.799)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25332",
    "data-name": "Rectangle 25332",
    width: 4.002,
    height: 0.584,
    transform: "translate(52.548 12.332)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275663",
    "data-name": "Path 275663",
    d: "M43.465,0H67.454V23.989H43.465ZM44.6,22.857H66.322V1.131H44.6Z",
    transform: "translate(44.914 -0.001)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25333",
    "data-name": "Rectangle 25333",
    width: 16.934,
    height: 7.511,
    transform: "translate(92.739 11.139)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25334",
    "data-name": "Rectangle 25334",
    width: 5.673,
    height: 16.389,
    transform: "translate(93.243 35.457)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25335",
    "data-name": "Rectangle 25335",
    width: 11.924,
    height: 7.125,
    transform: "translate(91.919 65.797)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275664",
    "data-name": "Path 275664",
    d: "M43.465,15.172H67.454V39.161H43.465ZM44.6,38.031H66.322V16.3H44.6Z",
    transform: "translate(44.914 15.677)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275665",
    "data-name": "Path 275665",
    d: "M43.465,30.345H67.454V54.334H43.465ZM44.6,53.2H66.322V31.478H44.6Z",
    transform: "translate(44.914 31.356)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336",
    "data-name": "Rectangle 25336",
    width: 8.676,
    height: 8.676,
    transform: "translate(96.035 7.656)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25337",
    "data-name": "Rectangle 25337",
    width: 8.676,
    height: 8.676,
    transform: "translate(96.035 38.507)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25338",
    "data-name": "Rectangle 25338",
    width: 8.676,
    height: 8.676,
    transform: "translate(96.035 69.359)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275666",
    "data-name": "Path 275666",
    d: "M15.688,64.3c-4.01.1-8.172.152-12.31.185l0-.185-.045-5.124c.006-.266-.069-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12L3.561,59.4l.228-.228L3.742,64.3l-.181-.183c4,.033,7.993.083,12.127.183h0",
    transform: "translate(3.438 60.908)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275667",
    "data-name": "Path 275667",
    d: "M12.361,67.478c-4.008.1-8.172.152-12.31.185l0-.185L0,62.354c.008-.266-.071-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12L.234,62.582l.228-.228L.415,67.478.234,67.3c4,.033,7.993.083,12.127.183h0",
    transform: "translate(0 64.192)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275668",
    "data-name": "Path 275668",
    d: "M75.6,26.813c-4.008.1-8.172.153-12.308.185l0-.185-.047-5.124c.008-.266-.071-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12-12.127.108.228-.228-.047,5.124-.181-.183c4,.033,7.993.083,12.127.183h0",
    transform: "translate(65.349 22.171)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275669",
    "data-name": "Path 275669",
    d: "M72.274,29.991c-4.008.1-8.172.152-12.308.185l0-.185-.047-5.124c.008-.266-.071-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12L60.147,25.1l.228-.228-.047,5.124-.181-.183c4,.033,7.993.083,12.127.183h0",
    transform: "translate(61.911 25.455)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275670",
    "data-name": "Path 275670",
    d: "M68.96,26.813c-4.008.1-8.172.153-12.308.185l0-.185L56.6,21.689c.008-.266-.071-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12-12.127.108.228-.228-.047,5.124-.181-.183c4,.033,7.993.083,12.127.183h0",
    transform: "translate(58.486 22.171)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275671",
    "data-name": "Path 275671",
    d: "M104.895,67.478c-4.008.1-8.172.152-12.31.185v-.185l-.047-5.124c.008-.266-.071-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12-12.127.108L93,62.354l-.047,5.124-.181-.183c4,.033,7.993.083,12.127.183h0",
    transform: "translate(95.619 64.192)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275672",
    "data-name": "Path 275672",
    d: "M101.568,5.836c-4.008.1-8.172.153-12.308.185l0-.185L89.211.712c.008-.266-.071-.234.23-.23L101.568.59l.124,0,0,.12Zm0,0L101.446.712l.122.12L89.441.94l.228-.228-.047,5.124-.181-.183c4,.033,7.993.081,12.127.183h0",
    transform: "translate(92.181 0.495)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275673",
    "data-name": "Path 275673",
    d: "M104.895,9.014c-4.008.1-8.172.153-12.31.185V9.014L92.538,3.89c.008-.266-.071-.234.23-.23l12.127.108.124,0,0,.12Zm0,0-.122-5.124.122.12-12.127.108L93,3.89l-.047,5.124-.181-.183c4,.033,7.993.083,12.127.183h0",
    transform: "translate(95.619 3.778)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275674",
    "data-name": "Path 275674",
    d: "M15.688,5.837c-4.01.1-8.172.153-12.31.185l0-.185L3.331.713c.008-.268-.071-.234.23-.23L15.688.591l.124,0,0,.12Zm0,0L15.566.713l.122.12L3.561.94,3.788.713,3.742,5.837l-.181-.183c4,.033,7.993.081,12.127.183h0",
    transform: "translate(3.438 0.494)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275675",
    "data-name": "Path 275675",
    d: "M195.638,88.879c0,4.689-43.426,8.489-96.994,8.489s-96.994-3.8-96.994-8.489S45.077,80.39,98.643,80.39s96.994,3.8,96.994,8.489",
    transform: "translate(1.704 83.069)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275676",
    "data-name": "Path 275676",
    d: "M1.043,76c48.977-.218,147.537-.218,196.5,0-48.979.218-147.539.218-196.5,0",
    transform: "translate(1.078 78.363)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275677",
    "data-name": "Path 275677",
    d: "M24.636,59.022l1.035,6.206,7.009,37.855h1.131l-5.1-37.855-.752-6.206Z",
    transform: "translate(25.458 60.989)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275678",
    "data-name": "Path 275678",
    d: "M27.961,59.022H24.636l1.035,6.206h3.042Z",
    transform: "translate(25.457 60.989)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275679",
    "data-name": "Path 275679",
    d: "M13.81,103.082h1.131L21.95,65.228l1.035-6.206H19.66l-.752,6.206Z",
    transform: "translate(14.271 60.989)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275680",
    "data-name": "Path 275680",
    d: "M17.07,59.022l-.752,6.206H19.36l1.035-6.206Z",
    transform: "translate(16.862 60.989)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275681",
    "data-name": "Path 275681",
    d: "M3.47,103.082H4.6l7.009-37.855,1.035-6.206H9.32l-.752,6.206Z",
    transform: "translate(3.586 60.989)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275682",
    "data-name": "Path 275682",
    d: "M5.977,65.227H9.019l1.035-6.206H6.729Z",
    transform: "translate(6.176 60.989)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275683",
    "data-name": "Path 275683",
    d: "M4.351,82.314H55.716V76.9H36.488L30.026,39.3H6.31Z",
    transform: "translate(4.496 40.612)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275684",
    "data-name": "Path 275684",
    d: "M4.351,82.314h2.8L8.977,39.3H6.31Z",
    transform: "translate(4.496 40.612)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275685",
    "data-name": "Path 275685",
    d: "M45.713,100.666c-1.021.128-28.9-6.377-29.8-7.253-.11-.1,1.208-5.451,1.208-5.451.439-2.2,7.7-20.181,7.7-20.181l18.225,4.5L35.317,88.942s3.475,2.351,6.46,4.593l.008.01a40.454,40.454,0,0,1,3.776,3.02c.887,1.061,1.173,3.981.152,4.1",
    transform: "translate(16.432 70.04)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275686",
    "data-name": "Path 275686",
    d: "M45.711,93.506c-1.021.128-28.9-6.375-29.8-7.253-.11-.1,1.21-5.451,1.21-5.451.146-.722,1.025-3.154,2.145-6.094l17.444,4.067L35.315,81.78s3.475,2.355,6.462,4.6l0,.008a39.556,39.556,0,0,1,3.778,3.022c.889,1.061,1.173,3.979.153,4.1",
    transform: "translate(16.432 77.198)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275687",
    "data-name": "Path 275687",
    d: "M45.9,92.406c-1.055.11-29.158-6.187-30.075-7.107-.354-.344,2.139-9.4,2.151-9.449l17.987,3.973-.075.305s9.038,6.93,9.939,8.046,1.129,4.126.073,4.231",
    transform: "translate(16.321 78.379)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275688",
    "data-name": "Path 275688",
    d: "M45.1,86.62c-4.711-1.177-23.825-5.486-28.57-6.291-.039-.008-.045.018-.006.028,4.644,1.271,23.79,5.423,28.56,6.34.1.02.116-.053.016-.077",
    transform: "translate(17.049 83.005)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275689",
    "data-name": "Path 275689",
    d: "M29.377,78.246a6.777,6.777,0,0,0-5.852.016c-.067.039-.01.134.053.128a26.936,26.936,0,0,1,5.738.089.122.122,0,0,0,.061-.234",
    transform: "translate(24.279 80.173)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275690",
    "data-name": "Path 275690",
    d: "M29.949,78.793a6.777,6.777,0,0,0-5.852.016c-.067.039-.01.134.053.128a26.8,26.8,0,0,1,5.738.089.122.122,0,0,0,.061-.234",
    transform: "translate(24.87 80.738)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275691",
    "data-name": "Path 275691",
    d: "M30.521,79.339a6.777,6.777,0,0,0-5.852.016c-.067.039-.01.134.053.128a26.8,26.8,0,0,1,5.738.089.122.122,0,0,0,.061-.234",
    transform: "translate(25.461 81.303)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275692",
    "data-name": "Path 275692",
    d: "M31.452,76.638c-.506-1.171-1.972-1.023-2.9-.545a10.171,10.171,0,0,0-3.829,3.621.049.049,0,0,0,.028.075.237.237,0,0,0,.24.3A17,17,0,0,0,30.02,79.1c.9-.425,1.909-1.356,1.431-2.464m-4,2.595c-.817.13-1.637.22-2.448.38a30.111,30.111,0,0,1,2.283-2.066,10.75,10.75,0,0,1,1.226-.844c.669-.38,3.1-.96,2.318,1.009-.435,1.086-2.405,1.366-3.379,1.521",
    transform: "translate(25.541 78.263)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275693",
    "data-name": "Path 275693",
    d: "M23.057,78.627a17.014,17.014,0,0,0,4.762,1.885c.165.055.291-.1.291-.25a.05.05,0,0,0,.043-.069,10.176,10.176,0,0,0-3.1-4.258c-.821-.641-2.237-1.051-2.946.008-.675,1,.144,2.1.956,2.684m-.543-1.517c-.415-2.08,1.875-1.065,2.462-.569a10.959,10.959,0,0,1,1.053,1.053A30.613,30.613,0,0,1,27.9,80.043c-.769-.307-1.558-.543-2.338-.821-.929-.329-2.816-.964-3.044-2.111",
    transform: "translate(22.58 77.803)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275694",
    "data-name": "Path 275694",
    d: "M43.106,111.441l-19.443-4.353S39.7,69.885,38.279,68c-.71-.941-18.723-1.218-24.451-6.072C6.388,55.63,11.38,46,11.38,46L31.5,45.4s-.244,4.2.541,4.835c.519.421,24.488,2.436,27.119,10.512,3.229,9.9-16.049,50.693-16.049,50.693",
    transform: "translate(10.066 46.913)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275695",
    "data-name": "Path 275695",
    d: "M35.269,78.428c-.514-.216-5.535-1.639-6.659-1.928-2.263-.577-4.53-1.149-6.806-1.682-1.185-.279-3.729-.884-3.882-.872a.063.063,0,0,0-.01.124c2.218.691,4.459,1.3,6.7,1.907s9.943,2.493,10.612,2.566c.065.008.118-.085.045-.116",
    transform: "translate(18.46 76.41)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275696",
    "data-name": "Path 275696",
    d: "M40.478,65.351a3.05,3.05,0,0,0-1.519-.472q-4.355-.729-8.711-1.46c-2.717-.455-5.447-.862-8.152-1.383a18.735,18.735,0,0,1-6.456-2.229,9.367,9.367,0,0,1-3.955-5.173,16.728,16.728,0,0,1-.512-6.629c.053-.541.153-1.08.252-1.612.008-.041-.057-.055-.063-.014-.736,4.12-.8,8.9,2.288,12.184a12.339,12.339,0,0,0,5.685,3.15,64.1,64.1,0,0,0,7.316,1.421q4.355.729,8.713,1.454c1.4.232,2.816.415,4.2.7a1.42,1.42,0,0,1,.756.336,1.083,1.083,0,0,1,.124,1.007c-.14.683-.325,1.358-.521,2.029-1.586,5.409-12.283,31.214-12.6,31.808-.035.063.065.112.1.051C30.092,95.778,37.843,75.848,39.6,70.732a32.434,32.434,0,0,0,1.143-3.981,1.355,1.355,0,0,0-.266-1.4",
    transform: "translate(11.307 47.901)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275697",
    "data-name": "Path 275697",
    d: "M67.394,98.494c-.976.327-28.878-.065-29.939-.744-.413-.392-.74-3.961-.992-8.4l-4.8-19.03,17.95-.148,5.256,18.9s3.874,1.612,7.247,3.217l.008.008a39.7,39.7,0,0,1,4.3,2.21c1.078.864,1.942,3.668.966,3.987",
    transform: "translate(32.718 72.511)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275698",
    "data-name": "Path 275698",
    d: "M65.612,89.348c-1.009.333-29.809.2-30.9-.506-.421-.258-.645-4.451-.771-9.524,0-.053,0-.106,0-.159l18.583-.118-.01.315s11,4.976,12.123,5.874,1.987,3.788.978,4.118",
    transform: "translate(35.071 81.675)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275699",
    "data-name": "Path 275699",
    d: "M64.242,83.642c-4.854-.142-24.447-.258-29.258-.03-.039,0-.039.028,0,.03,4.809.246,24.4.2,29.258.079.1,0,.1-.075,0-.079",
    transform: "translate(36.121 86.265)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275700",
    "data-name": "Path 275700",
    d: "M47.009,79.146A6.771,6.771,0,0,0,41.3,80.415c-.057.053.018.132.081.114A26.856,26.856,0,0,1,47,79.386a.121.121,0,0,0,.008-.24",
    transform: "translate(42.651 81.633)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275701",
    "data-name": "Path 275701",
    d: "M47.685,79.558a6.771,6.771,0,0,0-5.714,1.269c-.057.053.018.132.081.114A26.859,26.859,0,0,1,47.677,79.8a.121.121,0,0,0,.008-.24",
    transform: "translate(43.35 82.059)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275702",
    "data-name": "Path 275702",
    d: "M48.362,79.969a6.771,6.771,0,0,0-5.714,1.269c-.057.053.018.132.081.114a26.859,26.859,0,0,1,5.624-1.143.121.121,0,0,0,.008-.24",
    transform: "translate(44.049 82.483)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275703",
    "data-name": "Path 275703",
    d: "M48.331,77.342c-.744-1.037-2.145-.577-2.946.087a10.168,10.168,0,0,0-2.963,4.355.05.05,0,0,0,.045.069.238.238,0,0,0,.3.24,16.968,16.968,0,0,0,4.7-2.039c.791-.608,1.574-1.732.868-2.712m-3.349,3.39c-.771.3-1.551.565-2.31.895a29.967,29.967,0,0,1,1.787-2.505,10.725,10.725,0,0,1,1.017-1.088c.571-.514,2.826-1.6,2.481.488-.191,1.155-2.056,1.85-2.975,2.21",
    transform: "translate(43.832 79.289)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275704",
    "data-name": "Path 275704",
    d: "M40.854,80.671a17.039,17.039,0,0,0,5.055.823.239.239,0,0,0,.232-.307.05.05,0,0,0,.024-.077,10.176,10.176,0,0,0-3.945-3.5c-.939-.447-2.41-.547-2.877.641-.443,1.122.594,2.019,1.511,2.416M40,79.306c-.852-1.942,1.6-1.442,2.283-1.084a10.961,10.961,0,0,1,1.255.805,30.432,30.432,0,0,1,2.349,1.991c-.817-.134-1.639-.2-2.46-.3-.978-.124-2.956-.34-3.426-1.411",
    transform: "translate(40.546 79.881)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275705",
    "data-name": "Path 275705",
    d: "M80.706,114.12,59.76,114.1S50.8,78.538,49.209,76.511c-2.117-2.7-31.714-2.639-38.062-11.45-5.7-7.912-.889-19.109-.889-19.109l22.414-.665a46.122,46.122,0,0,1-2.078,7.05s27,4.976,34.567,13.247c5.1,5.582,15.545,48.536,15.545,48.536",
    transform: "translate(8.639 46.796)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275706",
    "data-name": "Path 275706",
    d: "M24.957,48a10.811,10.811,0,0,0-1.9.608c-.645.246-1.277.525-1.9.826a37.759,37.759,0,0,0-3.546,2c-.035.022,0,.071.037.053,1.212-.628,2.464-1.194,3.719-1.734l1.812-.779a19.311,19.311,0,0,0,1.83-.809c.077-.043.035-.183-.055-.167",
    transform: "translate(18.187 49.598)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275707",
    "data-name": "Path 275707",
    d: "M22.141,45.319c-.256,1.021-.482,2.052-.775,3.064-.134.464-.266.937-.441,1.387-.148.38-.374.815-.815.9-.508.1-.653-.338-.612-.756.047-.468.167-.935.258-1.395.108-.531.216-1.061.311-1.594.049-.266.1-.533.144-.8.012-.067.061-.577.1-.724,0,.012.012.024.028.022l.018,0a.037.037,0,0,0,.03-.026c0-.041,0-.049-.026-.077a.043.043,0,0,0-.047,0c-.1.055-.1.187-.134.285-.083.258-.167.516-.242.779-.142.486-.281.976-.4,1.468s-.244.984-.366,1.478a2.3,2.3,0,0,0-.1,1.135.869.869,0,0,0,.805.653c-.018.035-.039.065-.055.1-.045.1-.077.209-.116.311s-.073.211-.1.319a1.089,1.089,0,0,0-.03.159c-.006.059.006.118,0,.177a.085.085,0,0,0,.159.057c.026-.053.067-.094.1-.142a.761.761,0,0,0,.073-.173c.035-.1.065-.2.092-.309s.057-.205.077-.311c.01-.061.012-.124.018-.187a1.185,1.185,0,0,0,.59-.226,1.973,1.973,0,0,0,.612-.933c.155-.425.272-.866.392-1.3a19.133,19.133,0,0,0,.653-3.292.1.1,0,0,0-.185-.041",
    transform: "translate(19.661 46.754)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275708",
    "data-name": "Path 275708",
    d: "M52,77.415a16.5,16.5,0,0,0-1.68-.1c-.588-.024-1.177-.051-1.767-.069-1.161-.033-2.32-.055-3.481-.059-2.338-.008-4.675-.008-7.013.031-1.218.018-3.831.053-3.975.1a.06.06,0,0,0,.018.118c2.32.124,4.642.163,6.964.205s4.642.077,6.96.039c.643-.012,1.285-.037,1.928-.053a19.905,19.905,0,0,0,2.031-.087c.065-.01.091-.108.014-.12",
    transform: "translate(35.176 79.751)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275709",
    "data-name": "Path 275709",
    d: "M50.372,75.957a6.178,6.178,0,0,0-.874-1.8,3.2,3.2,0,0,0-1.716-.882c-5.584-1.529-11.346-2.214-17.023-3.288a69.4,69.4,0,0,1-8.286-2.019,32.137,32.137,0,0,1-7.839-3.526,8.758,8.758,0,0,1-2.883-3.044,13.159,13.159,0,0,1-1.354-3.8,23.225,23.225,0,0,1,.02-9.2,21.761,21.761,0,0,1,.573-2.239c.014-.047-.057-.063-.071-.018a22.362,22.362,0,0,0-1.263,9.14,13.674,13.674,0,0,0,2.6,7.666,10.79,10.79,0,0,0,3.223,2.529,34.236,34.236,0,0,0,3.947,1.858,52.436,52.436,0,0,0,8.137,2.43C33.223,71.012,39,71.649,44.666,72.907q1.046.235,2.088.5a7.362,7.362,0,0,1,2.058.663,3.583,3.583,0,0,1,1.157,1.95c.293.769,9.4,31.58,9.6,32.355.035.126.224.067.193-.057-.8-3.15-8.8-30.844-9.392-32.357",
    transform: "translate(9.917 47.647)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275710",
    "data-name": "Path 275710",
    d: "M34.768,63a3.022,3.022,0,0,0-1.025-1.8c-.582-.378-9.589-1.608-10.6-1.763-.047-.008-.065.063-.018.071.864.146,9.142,1.629,9.882,1.875a1.644,1.644,0,0,1,.807.523,3.506,3.506,0,0,1,.472,1.122q.384,1.2.765,2.405c.51,1.608,1.021,3.219,1.507,4.837.549,1.832,1.179,3.754,1.653,5.608.037.14.238.073.214-.065C37.8,72.335,35.034,63.842,34.768,63",
    transform: "translate(23.87 61.418)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275711",
    "data-name": "Path 275711",
    d: "M19.419,48.781a75.379,75.379,0,0,1,12.229,2.507,85.517,85.517,0,0,1,11.8,4.266c2.145.962,4.221,2.037,6.279,3.17.041.022,0,.081-.037.061a95.859,95.859,0,0,0-11.474-5,92.388,92.388,0,0,0-11.95-3.465c-2.283-.5-4.583-.882-6.887-1.265-.153-.026-.112-.287.043-.27",
    transform: "translate(19.924 50.406)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275712",
    "data-name": "Path 275712",
    d: "M19.9,39.829c2.125,4.725,10.423,19.933,15.512,20.828,3.341.586,16.669-1.24,18.847-4.5.95-1.419-1.131-10.97-2.9-10.516s-12.44,2.3-13.772,1.966S25.928,36.3,22.127,33.625c-6.555-4.614-3.373,3.66-2.229,6.2",
    transform: "translate(18.719 33.326)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275713",
    "data-name": "Path 275713",
    d: "M47.878,45.532l.858,14.439s-10.527,2.357-15.13.785c-5.592-1.907-13.827-19.168-14.955-22-1.854-4.66-1.356-7.487,1.248-6.806a10.741,10.741,0,0,1,3.981,2.477c1.71,1.49,11.541,11.157,14.64,12.979,1.732,1.019,9.357-1.869,9.357-1.869",
    transform: "translate(18.124 32.905)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87459",
    "data-name": "Group 87459",
    transform: "translate(35.663 64.749)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87458",
    "data-name": "Group 87458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87457",
    "data-name": "Group 87457",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275714",
    "data-name": "Path 275714",
    d: "M47.878,45.532l.858,14.439s-10.527,2.357-15.13.785c-5.592-1.907-13.827-19.168-14.955-22-1.854-4.66-1.356-7.487,1.248-6.806a10.741,10.741,0,0,1,3.981,2.477c1.71,1.49,11.541,11.157,14.64,12.979,1.732,1.019,9.357-1.869,9.357-1.869",
    transform: "translate(-17.539 -31.844)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275715",
    "data-name": "Path 275715",
    d: "M31.868,51.977c-.191-2.131-.653-10.874-.626-12.771,0-.13.087-.161.1-.024a115.549,115.549,0,0,1,.608,12.786c0,.053-.079.065-.083.01",
    transform: "translate(32.282 40.395)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87462",
    "data-name": "Group 87462",
    transform: "translate(35.663 64.75)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87461",
    "data-name": "Group 87461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87460",
    "data-name": "Group 87460",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275716",
    "data-name": "Path 275716",
    d: "M44.271,60.77c-3.434.5-8.026.887-10.667-.014-5.59-1.907-13.823-19.166-14.951-22-1.856-4.66-1.358-7.485,1.246-6.806.081.02.163.045.246.073Z",
    transform: "translate(-17.539 -31.844)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275717",
    "data-name": "Path 275717",
    d: "M36.645,64.229c-.634.616-27.788,3.442-27.922,3.259C8.363,67,13.436,41.516,24.311,32.736c1.915-1.547,5.112-.9,6.558.033.724.466,2.725,4.124,3.3,7.377s2.875,23.69,2.477,24.083",
    transform: "translate(8.995 32.866)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275718",
    "data-name": "Path 275718",
    d: "M25.594,31.952s2.963,15.394,3.058,16.023-.335,17.769-.335,17.769L8.152,68.235s2.279-8.512,2.4-8.92,4.39-14.534,8.981-20.866c4.221-5.819,6.059-6.5,6.059-6.5",
    transform: "translate(8.424 33.016)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87465",
    "data-name": "Group 87465",
    transform: "translate(16.578 64.968)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87464",
    "data-name": "Group 87464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87463",
    "data-name": "Group 87463",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275719",
    "data-name": "Path 275719",
    d: "M25.594,31.952s2.963,15.394,3.058,16.023-.335,17.769-.335,17.769L8.152,68.235s2.279-8.512,2.4-8.92,4.39-14.534,8.981-20.866c4.221-5.819,6.059-6.5,6.059-6.5",
    transform: "translate(-8.154 -31.952)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275720",
    "data-name": "Path 275720",
    d: "M19.81,32.392S21.845,46.05,21.9,46.912s1.6,17.475,1.6,17.475l2.489-.933S24.6,52.64,24.438,51.7s-1.322-10.994-1.757-12.875a25.659,25.659,0,0,0-2.871-6.436",
    transform: "translate(20.47 33.471)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87468",
    "data-name": "Group 87468",
    transform: "translate(40.281 65.862)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87467",
    "data-name": "Group 87467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87466",
    "data-name": "Group 87466",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275721",
    "data-name": "Path 275721",
    d: "M19.81,32.392S21.845,46.05,21.9,46.912s1.6,17.475,1.6,17.475l2.489-.933S24.6,52.64,24.438,51.7s-1.322-10.994-1.757-12.875a25.659,25.659,0,0,0-2.871-6.436",
    transform: "translate(-19.811 -32.391)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275722",
    "data-name": "Path 275722",
    d: "M40.44,56.873,23.707,58.581l5.622-22.263L46.062,34.61Z",
    transform: "translate(24.498 35.764)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275723",
    "data-name": "Path 275723",
    d: "M39.716,36.543c.941,1.789,3.215,3.967,3.455,5.449a1.725,1.725,0,0,1-.882,1.858A2.564,2.564,0,0,1,43.8,45.913c0,.712-1.141,1.334-1.141,1.334a2.055,2.055,0,0,1,1.114,1.826c-.065.98-1.2,1.456-1.2,1.456a2.453,2.453,0,0,1,.492,2.084c-.779,1.98-9.193,2.324-10.62-.722-.665-1.421,1.395-1.393,1.395-1.393s-2.95-.754-3.066-2.489,2.558-1.535,2.558-1.535-2.855-.756-2.792-2.564c.063-1.883,2.7-1.228,2.7-1.228s-1.924-1.192-1.558-2.564c.6-2.269,4.258.4,6.09-.112l.895-3.091Z",
    transform: "translate(31.563 37.761)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275724",
    "data-name": "Path 275724",
    d: "M37.377,41.29c-.742-1.771,1.395-4.085.927-5.88-.63-2.432-3.292.085-3.76,3.672l.126,2.847Z",
    transform: "translate(35.697 35.593)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275725",
    "data-name": "Path 275725",
    d: "M40.821,43.619a.022.022,0,0,1,.01.043,14.605,14.605,0,0,1-8.688-.163c-.087-.03-.075-.189.028-.173a29.945,29.945,0,0,0,8.65.293",
    transform: "translate(33.154 44.769)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275726",
    "data-name": "Path 275726",
    d: "M41.381,42.254c.033,0,.041.051.006.059a13.676,13.676,0,0,1-9.467-.767c-.1-.051-.142-.2-.02-.148,2.054.84,6.781,1.2,9.481.856",
    transform: "translate(32.885 42.767)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275727",
    "data-name": "Path 275727",
    d: "M31.82,39.478a18.807,18.807,0,0,0,9.107,1.383c.041,0,.041.057.006.069a12.322,12.322,0,0,1-5.116.22,8.43,8.43,0,0,1-4.044-1.57c-.047-.035-.016-.13.047-.1",
    transform: "translate(32.809 40.788)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275728",
    "data-name": "Path 275728",
    d: "M20.875,36.868C12.783,46.006,3.714,61.364,7.7,64.579c3.644,2.936,16.8-.043,25.047-3.375,1.57-.634-2.08-14.658-3.825-14.174-3.011.838-7.765,2.865-7.977,2.924-.453.13,1.722-5.323,4.392-11.934,2.981-7.373.163-6.375-4.463-1.151",
    transform: "translate(6.955 33.81)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275729",
    "data-name": "Path 275729",
    d: "M35.548,41.345a2.135,2.135,0,0,1-1.118,1.69,3,3,0,0,1,1.1,1.714c.214,1.214-1.6,2.084-1.6,2.084a3.682,3.682,0,0,1,.87,1.993c.087,1.183-1.612,2.32-1.612,2.32a3.237,3.237,0,0,1-.34,2.233c-1.082,1.775-11.551,3.133-12.971,3.257L17.358,42.022s8.91-4.453,11.289-4.166c2,.24,7.092,1.336,6.9,3.489",
    transform: "translate(17.937 39.103)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275730",
    "data-name": "Path 275730",
    d: "M29.059,41.021a27.09,27.09,0,0,0-6.492-1.277.038.038,0,0,0-.008.075c2.166.211,4.325,1.007,6.476,1.3a.053.053,0,0,0,.024-.1",
    transform: "translate(23.277 41.068)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275731",
    "data-name": "Path 275731",
    d: "M28.7,42.324a5.757,5.757,0,0,0-1.492-.191q-.8-.049-1.6-.067c-1.068-.028-2.135-.033-3.2,0-.047,0-.057.073-.008.075,1.063.031,2.127.075,3.188.15.531.037,1.063.077,1.594.124a6.9,6.9,0,0,0,1.5.057.076.076,0,0,0,.014-.144",
    transform: "translate(23.117 43.443)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275732",
    "data-name": "Path 275732",
    d: "M28.055,44.485a4.019,4.019,0,0,0-1.352-.1q-.732,0-1.46-.014c-.974-.016-1.946-.033-2.918-.083-.049,0-.057.073-.008.075.988.057,1.974.126,2.963.173.484.022.97.043,1.454.061a3.8,3.8,0,0,0,1.324-.061.027.027,0,0,0,0-.049",
    transform: "translate(23.027 45.762)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275733",
    "data-name": "Path 275733",
    d: "M25.091,32.987C19.2,36.621,4.061,58,6.848,63.878s21.775-.6,21.775-.6l-1.68-15.97s-4.994,2.81-5.161,2.556,2.743-7.546,3.928-10.512,2.513-8.3-.62-6.368",
    transform: "translate(6.726 33.661)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87471",
    "data-name": "Group 87471",
    transform: "translate(13.235 66.236)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87470",
    "data-name": "Group 87470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87469",
    "data-name": "Group 87469",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275734",
    "data-name": "Path 275734",
    d: "M25.091,32.987C19.2,36.621,4.061,58,6.848,63.878s21.775-.6,21.775-.6l-1.68-15.97s-4.994,2.81-5.161,2.556,2.743-7.546,3.928-10.512,2.513-8.3-.62-6.368",
    transform: "translate(-6.509 -32.575)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275735",
    "data-name": "Path 275735",
    d: "M17.01,53.74c-.352-2.109-1.474-10.793-1.59-12.686-.008-.132.073-.169.1-.033a116.617,116.617,0,0,1,1.574,12.7c.006.051-.075.069-.083.016",
    transform: "translate(15.934 42.3)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275736",
    "data-name": "Path 275736",
    d: "M22.552,39.834a11.544,11.544,0,0,0-1.6.738c-.47.234-.939.47-1.405.712-1.013.527-2.013,1.074-3.009,1.631s-1.985,1.122-2.965,1.7-1.926,1.216-2.9,1.8c-.047.026,0,.091.045.067,1-.567,2.029-1.065,3.038-1.606l2.965-1.592c.988-.529,1.978-1.051,2.965-1.584.484-.26.964-.525,1.446-.787a12.663,12.663,0,0,0,1.529-.884.112.112,0,0,0-.1-.2",
    transform: "translate(11 41.155)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275737",
    "data-name": "Path 275737",
    d: "M17.537,38.316c-.307.392-.608.785-.895,1.194-.051.075-.1.153-.15.23.077-.209.155-.419.234-.628a21.782,21.782,0,0,0,.791-2.216.032.032,0,0,0-.059-.02,22.117,22.117,0,0,0-1,2.245c-.313.736-.632,1.47-.929,2.21s-.608,1.482-.891,2.229a15.921,15.921,0,0,0-.76,2.237c-.01.043.053.061.075.024a17.024,17.024,0,0,0,1.029-2.231c.307-.738.594-1.486.891-2.229.124-.311.242-.624.36-.939.053-.071.1-.142.155-.211.142-.193.277-.4.407-.6.268-.419.519-.846.767-1.277.006-.014-.014-.028-.024-.016",
    transform: "translate(14.34 38.086)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275738",
    "data-name": "Path 275738",
    d: "M24.974,47.551c-.01-.106-.065-.128-.083-.014-.01.063-.018.177-.028.24-.649.173-3.011.895-3.589,1.067q-1.818.537-3.666.948t-3.733.706c-1.244.2-2.507.4-3.764.48a.04.04,0,0,0,0,.079c1.285-.067,2.558-.1,3.837-.25,1.251-.144,2.5-.354,3.729-.612,1.255-.262,2.5-.584,3.727-.958.612-.187,1.222-.39,1.826-.6a9.236,9.236,0,0,0,1.708-.689.135.135,0,0,0,.059-.12c-.008-.091-.018-.181-.026-.272",
    transform: "translate(10.41 49.042)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275739",
    "data-name": "Path 275739",
    d: "M21.84,39.75c-1.566.342-4.2-2.082-5.228-4.03-.069-.134.569-5.415.588-6.474,0-.218,6.627,1.726,6.627,1.726a16.9,16.9,0,0,0-.712,4.059c0,.155.238,4.388-1.275,4.719",
    transform: "translate(17.161 30.202)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275740",
    "data-name": "Path 275740",
    d: "M23.424,30.962l0,0c-.01.033-.049.163-.106.37-.1.354-.248.931-.37,1.59a12.03,12.03,0,0,0-.234,2.094c0,.049,0,.1,0,.146v.022c.006.087.008.2.008.34a4.1,4.1,0,0,1-.647.026c-3.619-.142-4.764-4.608-5.073-6.318.039,0,.075.012.116.02.175.031.4.083.681.148.069.018.138.037.214.053.441.11.968.252,1.517.4.179.049.36.1.543.15.392.112.789.222,1.157.323.159.049.315.094.462.132.163.045.323.094.472.132.073.022.146.045.216.063.037.012.069.022.1.031l.549.159c.11.033.2.059.262.075s.094.026.112.037l.018,0Z",
    transform: "translate(17.568 30.212)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275741",
    "data-name": "Path 275741",
    d: "M16.922,27.039c-.917,2.288-.256,9.176,1.287,10.83,2.239,2.4,6.189,2.946,8.3.2,2.048-2.668,1.025-11.629-.726-13.162-2.578-2.259-7.509-1.24-8.865,2.137",
    transform: "translate(17.053 24.483)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275742",
    "data-name": "Path 275742",
    d: "M19.992,27.572c-.006-.016-.035.026-.03.045.071.462.073,1-.327,1.206-.012.006-.008.031.006.026.5-.134.492-.852.352-1.277",
    transform: "translate(20.281 28.487)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275743",
    "data-name": "Path 275743",
    d: "M19.835,27.357c-.752.033-.63,1.533.065,1.5s.565-1.531-.065-1.5",
    transform: "translate(19.966 28.268)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275744",
    "data-name": "Path 275744",
    d: "M21.137,27.5c0-.018.039.018.039.039.022.466.128,1,.561,1.116.012,0,.014.026,0,.026-.519-.031-.651-.736-.6-1.181",
    transform: "translate(21.831 28.415)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275745",
    "data-name": "Path 275745",
    d: "M21.511,27.249c.744-.118.923,1.379.234,1.486s-.856-1.389-.234-1.486",
    transform: "translate(21.833 28.15)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275746",
    "data-name": "Path 275746",
    d: "M19.486,27.61a5.839,5.839,0,0,0,.565-.252.99.99,0,0,0,.527-.366.321.321,0,0,0-.081-.38.79.79,0,0,0-.8-.016,1.161,1.161,0,0,0-.626.553.34.34,0,0,0,.417.462",
    transform: "translate(19.666 27.377)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275747",
    "data-name": "Path 275747",
    d: "M22.224,27.334a5.622,5.622,0,0,1-.61-.106,1.012,1.012,0,0,1-.6-.228A.32.32,0,0,1,21,26.612a.785.785,0,0,1,.771-.211,1.162,1.162,0,0,1,.742.384.339.339,0,0,1-.291.549",
    transform: "translate(21.641 27.262)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275748",
    "data-name": "Path 275748",
    d: "M19.789,29.713c.12.1.244.24.413.242a1.209,1.209,0,0,0,.49-.159c.014-.006.03.008.022.022a.627.627,0,0,1-.569.3.5.5,0,0,1-.4-.382c-.01-.026.024-.039.043-.024",
    transform: "translate(20.402 30.697)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275749",
    "data-name": "Path 275749",
    d: "M19.957,31.653a1.588,1.588,0,0,0,1.114.618,2,2,0,0,0,.571-.018.634.634,0,0,0,.108-.022.707.707,0,0,0,.1-.024.115.115,0,0,0,.085-.11v0l-.008-.047v0l0-.041c-.02-.36-.1-.9-.1-.9.136.055.828.3.8.116a23.813,23.813,0,0,0-1-4.742.043.043,0,0,0-.083.018c.15,1.488.561,2.942.736,4.435a2.822,2.822,0,0,0-.765-.167c-.051.018.171,1.045.167,1.206l0,.018A2.2,2.2,0,0,1,20,31.609c-.037-.024-.071.01-.041.045",
    transform: "translate(20.61 27.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275750",
    "data-name": "Path 275750",
    d: "M21.483,29.447a1.912,1.912,0,0,1-.706.645.87.87,0,0,1-.512.073c-.376-.069-.413-.409-.37-.706a2.081,2.081,0,0,1,.13-.46,2.445,2.445,0,0,0,1.458.447",
    transform: "translate(20.544 29.966)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275751",
    "data-name": "Path 275751",
    d: "M20.778,29.856a.833.833,0,0,1-.51.073c-.38-.067-.417-.407-.372-.7a.874.874,0,0,1,.882.63",
    transform: "translate(20.543 30.2)",
    fill: "#ffe7cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87474",
    "data-name": "Group 87474",
    transform: "translate(38.513 52.101)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87473",
    "data-name": "Group 87473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87472",
    "data-name": "Group 87472",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275752",
    "data-name": "Path 275752",
    d: "M21.561,26.041a5.641,5.641,0,0,0,.765.024c.258-.02.51-.092.769-.1a4.127,4.127,0,0,1,1.44.248c.041.012.035.039-.006.028A3.615,3.615,0,0,0,23,26.092a4.539,4.539,0,0,1-1.263.075,4.544,4.544,0,0,0-2.794.407l-.006-.008a4.583,4.583,0,0,1,2.619-.525",
    transform: "translate(-18.939 -25.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275753",
    "data-name": "Path 275753",
    d: "M21.47,25.7a5.4,5.4,0,0,0,.726.022c.244-.018.482-.085.728-.1a3.888,3.888,0,0,1,1.364.236c.039.01.033.037-.006.026a3.407,3.407,0,0,0-1.444-.138,4.369,4.369,0,0,1-1.2.071,4.328,4.328,0,0,0-2.651.384l0-.008a4.34,4.34,0,0,1,2.483-.5",
    transform: "translate(-18.893 -25.623)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275754",
    "data-name": "Path 275754",
    d: "M27.464,28.853c-2.357,1.651-5.632-.773-5.632-.773a2.581,2.581,0,0,1-2.6,1.659s-.423,4.018-1.482,4.022c-1.614.008-2.172-5.46-1.673-6.541a2.873,2.873,0,0,1,1.865-1.37,2.636,2.636,0,0,1,1.08-1.608c1.094-.854,4.911.24,4.911.24a3.537,3.537,0,0,1,.962-1.324,1,1,0,0,1,1.438.116,2.4,2.4,0,0,0-.376.994c-.179,1.177.783,1.165.763.1a1.655,1.655,0,0,0-.386-1.094c.468-.7,1.24-.935,1.714-.567.86.667,1.383,4.776-.577,6.147",
    transform: "translate(16.427 23.283)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275755",
    "data-name": "Path 275755",
    d: "M20.4,31.17a2.168,2.168,0,1,1,.535-.045,2.165,2.165,0,0,1-.535.045m.181-4.03a1.894,1.894,0,0,0-.464.037,1.873,1.873,0,1,0,.464-.037",
    transform: "translate(18.945 27.743)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275756",
    "data-name": "Path 275756",
    d: "M22.606,30.979a2.017,2.017,0,0,1-1.619-2.041,2.568,2.568,0,0,1,.348-1.539,1.345,1.345,0,0,1,2.3-.167,2.58,2.58,0,0,1,.563,1.474,1.952,1.952,0,0,1-1.448,2.271c-.049,0-.1,0-.142,0m-.039-4.026a.661.661,0,0,0-.11,0,1.153,1.153,0,0,0-.878.6,2.291,2.291,0,0,0-.3,1.364c.073,1.031.722,1.826,1.45,1.773s1.257-.931,1.183-1.962a2.282,2.282,0,0,0-.5-1.307,1.183,1.183,0,0,0-.844-.466",
    transform: "translate(21.68 27.551)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275757",
    "data-name": "Path 275757",
    d: "M20.512,28.154l-.2-.207a1.181,1.181,0,0,1,1.6-.2l-.2.214c-.506-.472-1.177.165-1.206.191",
    transform: "translate(20.988 28.417)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275758",
    "data-name": "Path 275758",
    d: "M15.842,29.226l-.266-.114c.055-.124.539-1.214,1.173-1.364.6-.14,4.484-.055,4.648-.051l-.006.289c-1.114-.026-4.115-.065-4.575.043-.419.1-.846.9-.974,1.2",
    transform: "translate(16.095 28.589)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275759",
    "data-name": "Path 275759",
    d: "M18.683,29.074s-1.395-2.3-2.43-1.814S16.17,31,17.312,31.514a1.194,1.194,0,0,0,1.639-.535Z",
    transform: "translate(16.337 28.099)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275760",
    "data-name": "Path 275760",
    d: "M16.184,27.682a.016.016,0,0,0-.01.031A3.007,3.007,0,0,1,17.607,29.7a.657.657,0,0,0-.972-.244c-.022.014,0,.049.02.045a.733.733,0,0,1,.789.307,3.474,3.474,0,0,1,.344.677c.035.077.169.047.146-.041l0-.018c.087-1.045-.63-2.562-1.747-2.741",
    transform: "translate(16.703 28.604)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275761",
    "data-name": "Path 275761",
    d: "M23.84,32.89l-1.59,3.955-4.915-5.006-1.393,1.606s4.807,7.952,4.837,7.595l1.631-3.41L24.763,40l-.189-5.956Z",
    transform: "translate(16.474 32.9)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275762",
    "data-name": "Path 275762",
    d: "M24.735,36.051c-.065-.982-.1-1.972-.211-2.952,0-.035-.057-.049-.067-.008a54.084,54.084,0,0,0,.065,5.6l-.01-.01c-.1-.1-2.182-2.088-2.2-2.058-.354.543-1.551,3.026-1.633,3.251-.76-1.265-3.674-5.856-4.573-7.052a.034.034,0,0,0-.059.035c.671,1.334,4.526,7.519,4.585,7.5a37.764,37.764,0,0,0,1.706-3.605A25.983,25.983,0,0,0,24.8,39.284a30.625,30.625,0,0,0-.063-3.233",
    transform: "translate(16.575 33.903)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25345",
    "data-name": "Rectangle 25345",
    width: 32.186,
    height: 72.017,
    transform: "translate(103.204 99.19)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87477",
    "data-name": "Group 87477",
    transform: "translate(103.204 99.191)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87476",
    "data-name": "Group 87476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87475",
    "data-name": "Group 87475",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25346",
    "data-name": "Rectangle 25346",
    width: 32.186,
    height: 72.017,
    transform: "translate(0 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25348",
    "data-name": "Rectangle 25348",
    width: 32.186,
    height: 72.017,
    transform: "translate(12.21 99.19)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25349",
    "data-name": "Rectangle 25349",
    width: 90.994,
    height: 10.004,
    transform: "translate(44.396 99.192)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87480",
    "data-name": "Group 87480",
    transform: "translate(44.398 99.191)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87479",
    "data-name": "Group 87479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87478",
    "data-name": "Group 87478",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25350",
    "data-name": "Rectangle 25350",
    width: 90.994,
    height: 10.004,
    transform: "translate(-0.002 0.001)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87483",
    "data-name": "Group 87483",
    transform: "translate(44.604 104.069)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87482",
    "data-name": "Group 87482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87481",
    "data-name": "Group 87481",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275763",
    "data-name": "Path 275763",
    d: "M21.936,51.3c22.629-.163,68.164-.163,90.787,0-22.627.163-68.164.163-90.787,0",
    transform: "translate(-21.936 -51.181)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25353",
    "data-name": "Rectangle 25353",
    width: 4.331,
    height: 72.017,
    transform: "translate(44.398 99.19)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87486",
    "data-name": "Group 87486",
    transform: "translate(44.398 99.191)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87485",
    "data-name": "Group 87485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87484",
    "data-name": "Group 87484",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25354",
    "data-name": "Rectangle 25354",
    width: 4.331,
    height: 72.017,
    transform: "translate(0 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25356",
    "data-name": "Rectangle 25356",
    width: 4.331,
    height: 72.017,
    transform: "translate(131.061 99.19)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87489",
    "data-name": "Group 87489",
    transform: "translate(131.061 99.191)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87488",
    "data-name": "Group 87488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87487",
    "data-name": "Group 87487",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25357",
    "data-name": "Rectangle 25357",
    width: 4.331,
    height: 72.017,
    transform: "translate(0 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25359",
    "data-name": "Rectangle 25359",
    width: 26.342,
    height: 1.181,
    transform: "translate(60.825 98.009)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25360",
    "data-name": "Rectangle 25360",
    width: 13.257,
    height: 1.181,
    transform: "translate(73.908 98.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275764",
    "data-name": "Path 275764",
    d: "M37.05,57.643H62.72l3.357-17.436H40.407Z",
    transform: "translate(38.285 41.547)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275765",
    "data-name": "Path 275765",
    d: "M43.422,45.29a1.409,1.409,0,0,0,1.425,1.562,1.739,1.739,0,0,0,1.7-1.562,1.41,1.41,0,0,0-1.425-1.564,1.741,1.741,0,0,0-1.7,1.564",
    transform: "translate(44.864 45.183)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275766",
    "data-name": "Path 275766",
    d: "M79.849,59.022l-1.035,6.206-7.009,37.855H70.675l5.1-37.855.752-6.206Z",
    transform: "translate(73.031 60.989)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275767",
    "data-name": "Path 275767",
    d: "M73.934,59.022h3.325l-1.035,6.206H73.182Z",
    transform: "translate(75.622 60.989)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275768",
    "data-name": "Path 275768",
    d: "M90.675,103.082H89.545L82.536,65.228,81.5,59.022h3.324l.752,6.206Z",
    transform: "translate(84.218 60.989)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275769",
    "data-name": "Path 275769",
    d: "M84.825,59.022l.752,6.206H82.535L81.5,59.022Z",
    transform: "translate(84.218 60.989)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275770",
    "data-name": "Path 275770",
    d: "M101.015,103.082H99.885L92.876,65.228l-1.035-6.206h3.325l.752,6.206Z",
    transform: "translate(94.903 60.989)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275771",
    "data-name": "Path 275771",
    d: "M95.918,65.227H92.876l-1.035-6.206h3.325Z",
    transform: "translate(94.903 60.989)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275772",
    "data-name": "Path 275772",
    d: "M121.575,82.314H70.211V76.9H89.438L95.9,39.3h23.717Z",
    transform: "translate(72.551 40.612)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275773",
    "data-name": "Path 275773",
    d: "M97.822,82.314h-2.8L93.2,39.3h2.668Z",
    transform: "translate(96.304 40.612)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275774",
    "data-name": "Path 275774",
    d: "M55.041,91.539c.95.555,30.156,6.659,31.417,6.189.48-.177,1.616-4.378,2.847-9.494.266-1.106.533-2.249.8-3.41,1.73-7.54,3.392-15.581,3.392-15.581L73.969,65.1,71.114,80.8l-.628,3.444S58.258,86.907,56.93,87.571s-2.839,3.412-1.889,3.967",
    transform: "translate(56.569 67.271)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275775",
    "data-name": "Path 275775",
    d: "M88.831,79.995c-1.039,4.195-1.956,7.387-2.373,7.544-1.259.472-30.47-5.638-31.417-6.194s.567-3.3,1.887-3.965c.819-.409,5.789-1.58,9.475-2.418-3.219.769-9.227,2.952,3.2,3.851,10.272.746,17.052,1.086,19.231,1.181",
    transform: "translate(56.57 77.46)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275776",
    "data-name": "Path 275776",
    d: "M68.111,101.236c1.059.295,30.858-1.244,31.956-2.021.419-.293-.728-12.257-1.039-13.406-1.057-3.9-6.094-15.638-6.094-15.638L73,71.143l8.186,19.1S70.041,95.938,68.926,96.92s-1.875,4.022-.815,4.317",
    transform: "translate(69.859 72.51)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275777",
    "data-name": "Path 275777",
    d: "M100.068,88.069c-1.1.779-30.895,2.318-31.958,2.025s-.293-3.339.815-4.319a62.4,62.4,0,0,1,5.945-3.381c-3.426,1.93-8.849,6.23,24.886-1.438.307,3.412.535,6.956.311,7.113",
    transform: "translate(69.859 83.654)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275778",
    "data-name": "Path 275778",
    d: "M115.923,65.866c-5.939,6.616-25.895,1.391-27.088,4.024C87.786,72.212,101.4,109.5,101.4,109.5L79.612,111.85S60.8,70.667,67.524,58.77c3.634-6.427,19.636-3.865,29.294-5.041,2.914-.356,4.282-6.362,4.282-6.362h17.257s4.355,10.937-2.434,18.5",
    transform: "translate(68.275 48.945)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275779",
    "data-name": "Path 275779",
    d: "M69.766,55.082l18.3,14c6.078-.13,19.38,1.976,24.042-3.221,6.789-7.562,2.436-18.5,2.436-18.5H97.283S95.915,53.374,93,53.729c-6.779.821-16.675-.191-23.237,1.352",
    transform: "translate(72.092 48.945)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275780",
    "data-name": "Path 275780",
    d: "M72.341,77.681c.6-.189,6.253-.819,7.5-.954,2.493-.268,10.348-1,11.769-1a.034.034,0,0,1,.008.067c-1.236.258-6.248.844-7.495.972-2.5.256-11.078,1.088-11.771,1.019a.054.054,0,0,1-.01-.106",
    transform: "translate(74.712 78.253)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275781",
    "data-name": "Path 275781",
    d: "M76.017,67.04c1.4-.7,12.021-.352,19.642-1.065a11.974,11.974,0,0,0,6.871-2.389A11.358,11.358,0,0,0,105.921,58a24.981,24.981,0,0,0,.531-7.987c-.031-.657-.075-1.312-.116-1.968,0-.037.065-.045.069-.006.58,4.776,1.023,10.114-2.084,14.256a10,10,0,0,1-5.555,3.644c-4.6,1.208-21.877.909-22.487,1.375-.726.555,10.445,34.569,10.667,35.215.041.122-.171.205-.224.083C85.62,100,74.8,67.645,76.017,67.04",
    transform: "translate(78.452 49.61)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275782",
    "data-name": "Path 275782",
    d: "M66.876,56.007c1.027-2.609,3.371-4.231,6.818-4.854.059-.01.055.075,0,.091-3.007.878-5.159,2.088-6.342,4.628a14.734,14.734,0,0,0-.98,5.083c-.716,11.137,9,36.417,9.2,36.856a.034.034,0,0,1-.059.033c-1.368-2.306-12.875-31.074-8.634-41.838",
    transform: "translate(68.141 52.857)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275783",
    "data-name": "Path 275783",
    d: "M62.528,98.579l16.5,3.51s-13.017-38.853-6.9-43.865c1.694-1.389,5.388-1.875,9.78.022,6.555,2.83,14.144,8.605,21.3,10.716,6.7,1.978,14.654.159,17.391-2.855,5.75-6.328,1.425-18.29,1.425-18.29L98.29,46.926s.354.287-.779,1.291c0,0-13.949-3.162-20.008.541-10.931,6.68-14.976,49.821-14.976,49.821",
    transform: "translate(64.613 48.49)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275784",
    "data-name": "Path 275784",
    d: "M86.877,48.061a.043.043,0,0,1,.083.014,13.247,13.247,0,0,0,.205,2.66,4.585,4.585,0,0,0,1.194,2.21c1.3,1.318,3.166,1.765,4.872,2.3.089.028.073.187-.026.173a8.991,8.991,0,0,1-5.266-2.19,4.612,4.612,0,0,1-1.224-2.383,5.7,5.7,0,0,1,.163-2.786",
    transform: "translate(89.503 49.633)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275785",
    "data-name": "Path 275785",
    d: "M68.747,52.516c2.538-1.592,6.5-.382,8.4.346.039.014.02.079-.02.063-1.747-.628-6.092-1.578-8.416.067-5.368,3.8,1.818,29.815,6.529,44.13.073.224-.1.165-.2-.051-.777-1.7-6.85-19.786-8.434-31.753-.244-1.84-1.515-10.506,2.143-12.8",
    transform: "translate(68.4 53.457)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275786",
    "data-name": "Path 275786",
    d: "M63.479,70.171c.5-.012,4.774.929,5.716,1.143,1.885.423,6.253,1.553,7.271,1.944.026.01.01.067-.018.063-.98-.094-3.255-.592-4.195-.809-1.883-.437-8.333-1.987-8.8-2.239-.041-.022-.018-.1.031-.1",
    transform: "translate(65.542 72.51)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275787",
    "data-name": "Path 275787",
    d: "M67.851,55.94a9.379,9.379,0,0,1,5.634-.852,19.689,19.689,0,0,1,5.756,1.8c3.859,1.765,7.538,3.92,11.4,5.675a32.163,32.163,0,0,0,12.18,3.243c3.621.11,8.2-.527,10.531-3.784,3.585-5.016,1.5-13.668,1.454-14.225,0-.045.057-.043.067,0,2.782,10.634-.8,14.762-3.213,16.5-1.919,1.379-4.677,1.726-6.5,1.881a27.469,27.469,0,0,1-12.34-2.231c-4-1.594-7.755-3.741-11.588-5.7-3.678-1.881-7.775-3.821-11.972-2.743a10.289,10.289,0,0,0-1.4.478c-.022.008-.037-.028-.016-.041",
    transform: "translate(70.103 49.358)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275788",
    "data-name": "Path 275788",
    d: "M80.173,43.4a105.8,105.8,0,0,0,.72,16.112c.59,4.118,2.477,7.448,6.82,8.278,4.03.765,9.707.445,12.967-2.346a5.514,5.514,0,0,0,1.8-5.008c-.262-2.7-3.058-17.452-3.9-22.052a48.094,48.094,0,0,0-2.015-8.329c-2.1-5.634-4.931-5.464-5.327-5.561a7.311,7.311,0,0,0-5.606.043A6.035,6.035,0,0,0,82.1,27.962C80.08,32.645,80.234,38.4,80.173,43.4",
    transform: "translate(82.823 24.774)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275789",
    "data-name": "Path 275789",
    d: "M86.071,24.6c3.471,1.442,4.443,5.12,5.413,8.412C92.832,37.6,94.1,42.2,95.15,46.865c.5,2.243.956,4.5,1.34,6.761a35.873,35.873,0,0,1,.846,6.684c-.083,3.652-3.343,5.455-6.547,6.114a.125.125,0,0,1-.059-.242,9.512,9.512,0,0,0,4.986-2.46c1.68-1.826,1.377-4.1,1.07-6.364-.523-3.853-1.263-7.674-2.141-11.462s-1.893-7.554-2.965-11.3c-1.019-3.562-1.852-8.274-5.626-9.941-.035-.016-.018-.073.018-.059",
    transform: "translate(88.902 25.417)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275790",
    "data-name": "Path 275790",
    d: "M81.008,31.2c.525-2.81,1.852-5.586,4.746-6.523l0,.01c-3.733,1.37-4.475,5.549-4.829,9.028q-.558,5.493-.708,11.013c-.1,3.538-.122,7.1.1,10.636.24,3.815,1.088,7.359,3.479,10.407.049.063-.035.146-.091.087-2.332-2.448-3.221-5.923-3.542-9.2a99.047,99.047,0,0,1-.185-13.046A83.986,83.986,0,0,1,81.008,31.2",
    transform: "translate(82.519 25.495)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275791",
    "data-name": "Path 275791",
    d: "M101.435,39.668C96.183,46.124,89,52.224,85.992,52.124c-2.428-.079-16.96-8.8-17.985-10.122-.88-1.139,5.954-9.949,7.369-9.341,2.377,1.017,10.823,8,11.543,7.9.746-.114,6.639-2.686,12.525-5.457,5.634-2.651,5.638.085,1.991,4.569",
    transform: "translate(70.193 33.718)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275792",
    "data-name": "Path 275792",
    d: "M74.391,46.762a57.8,57.8,0,0,1-7.444-5.427c-1.2-1.285-4.372-5.236-3.481-6.253s1.915.065,1.915.065-1.078-1.879-.087-2.82,2.525.793,2.525.793-.964-2.011.092-2.879,2.306,1.135,2.306,1.135-.968-1.8.2-2.147c1.407-.421,2.818,3.1,4.246,4.416.323.3,7,5.61,7,5.61Z",
    transform: "translate(65.421 30.166)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275793",
    "data-name": "Path 275793",
    d: "M66.72,30.223a9.78,9.78,0,0,0,4.172,5.136c.045.031.008.1-.041.073-2.324-1.37-3.627-2.4-4.26-5.165-.031-.136.079-.169.128-.045",
    transform: "translate(68.806 31.15)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275794",
    "data-name": "Path 275794",
    d: "M65.555,31.053a14.694,14.694,0,0,0,4.5,5.478c.031.026-.01.081-.045.057-2.318-1.633-3.595-2.688-4.573-5.447-.045-.126.059-.205.12-.087",
    transform: "translate(67.606 32.028)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275795",
    "data-name": "Path 275795",
    d: "M64.437,32.215a13.189,13.189,0,0,0,4.847,5.12.052.052,0,0,1-.051.089,9.349,9.349,0,0,1-4.866-5.157c-.069-.163-.022-.205.069-.053",
    transform: "translate(66.48 33.191)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275796",
    "data-name": "Path 275796",
    d: "M77.921,38.73a34.2,34.2,0,0,0-1.938-4.648c-.813-1.344-5.689-5.232-6.59-4.227-1.161,1.3,1.212,4.1,2.552,5.317,0,0-2.69,3-1.421,5.378s7.4-1.82,7.4-1.82",
    transform: "translate(71.386 30.679)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275797",
    "data-name": "Path 275797",
    d: "M69.2,30c-.205,1.948,1.659,3.434,2.871,4.715a.162.162,0,0,1-.043.262c-1.043,1.332-2.127,3.516-1.6,5.224a.041.041,0,0,1-.075.03c-.811-1.755.077-3.987,1.314-5.374C70.4,33.568,68.6,31.994,69.183,30c0-.012.02-.01.018,0",
    transform: "translate(71.373 30.992)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275798",
    "data-name": "Path 275798",
    d: "M78.583,34.729,69.561,45.9s11.982,6.44,15.1,5.854,6.985-3.3,14.752-12.2c6.151-7.052,1.283-7.113-2.55-5.187-3.133,1.572-11.092,5.161-11.722,4.88s-6.562-4.52-6.562-4.52",
    transform: "translate(71.88 34.4)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275799",
    "data-name": "Path 275799",
    d: "M69.562,45.9s10.84,5.826,14.581,5.891a2.751,2.751,0,0,0,.521-.037c3.119-.59,6.987-3.3,14.756-12.2,2.719-3.119,3.284-4.87,2.739-5.687-.7-1.025-3.152-.573-5.293.5-3.129,1.572-11.09,5.163-11.722,4.88s-6.558-4.52-6.558-4.52Z",
    transform: "translate(71.881 34.4)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275800",
    "data-name": "Path 275800",
    d: "M79.064,35.136c-1.222,1.73-2.527,3.406-3.861,5.049-.657.807-1.312,1.617-2,2.4-.714.815-1.476,1.588-2.184,2.405-.033.037-.092-.008-.061-.047.679-.836,1.3-1.724,1.96-2.576.636-.821,1.3-1.623,1.952-2.432,1.334-1.647,2.676-3.292,4.067-4.892a.078.078,0,0,1,.124.1",
    transform: "translate(73.318 36.178)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275801",
    "data-name": "Path 275801",
    d: "M81.09,55.01,80.8,61.047s7.135.783,24.78.783c0,0-3.721-18.835-9.693-25.846-2.987-3.508-6.659-3.4-9.085-1.12-.614.575-6.3,10.112-7.184,13.642-.769,3.113,1.472,6.5,1.472,6.5",
    transform: "translate(82.106 34.345)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275802",
    "data-name": "Path 275802",
    d: "M85.631,35.012c-1.169,4.5-3.636,9.04-3.453,13.721a13.1,13.1,0,0,0,1.734,4.453q-.186,3.19-.492,6.377-.012-3.2.1-6.395A11.139,11.139,0,0,1,81.731,48.8c-.2-4.845,2.373-9.313,3.9-13.79",
    transform: "translate(84.446 36.178)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275803",
    "data-name": "Path 275803",
    d: "M81.962,38.135a.4.4,0,0,0,.311.443.361.361,0,0,0,.4-.34.392.392,0,0,0-.311-.441.359.359,0,0,0-.4.338",
    transform: "translate(84.692 39.052)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275804",
    "data-name": "Path 275804",
    d: "M81.272,40.314a.4.4,0,0,0,.311.443.361.361,0,0,0,.4-.34.392.392,0,0,0-.311-.441.36.36,0,0,0-.4.338",
    transform: "translate(83.979 41.305)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275805",
    "data-name": "Path 275805",
    d: "M81.272,42.5a.4.4,0,0,0,.311.443.361.361,0,0,0,.4-.34.392.392,0,0,0-.311-.441.359.359,0,0,0-.4.338",
    transform: "translate(83.979 43.568)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275806",
    "data-name": "Path 275806",
    d: "M81.962,44.287a.4.4,0,0,0,.311.443.361.361,0,0,0,.4-.34.392.392,0,0,0-.311-.441.359.359,0,0,0-.4.338",
    transform: "translate(84.692 45.409)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275807",
    "data-name": "Path 275807",
    d: "M81.816,46.273a.4.4,0,0,0,.311.443.361.361,0,0,0,.4-.34.392.392,0,0,0-.311-.441.359.359,0,0,0-.4.338",
    transform: "translate(84.541 47.462)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275808",
    "data-name": "Path 275808",
    d: "M83.28,36.853c-.6,1.011-1.161,2.046-1.706,3.087.132-.492.293-.976.46-1.456.014-.039-.049-.063-.065-.026a6.817,6.817,0,0,0-.577,1.832c-.175.338-.356.673-.529,1.015-.34.679-.685,1.354-.96,2.064a7.181,7.181,0,0,0-.455,2.224c0,.041.065.049.069.008a7.931,7.931,0,0,1,.712-2.216c.307-.7.653-1.389.988-2.078.716-1.47,1.425-2.942,2.1-4.433a.021.021,0,0,0-.037-.02",
    transform: "translate(82.096 38.069)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275809",
    "data-name": "Path 275809",
    d: "M96.195,36.329c3.863,6.692,10.687,20.447,8.4,24.254-2.267,3.774-15.14,6.269-19.538,7.05-1.448.256-6.678-10.065-5.238-10.7,2.442-1.08,14.044-3.186,14.414-3.973.234-.492-2.041-9.508-2.31-14.811-.35-6.891,3.07-3.9,4.27-1.82",
    transform: "translate(82.225 34.99)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275810",
    "data-name": "Path 275810",
    d: "M90.349,45s-4.563.634-7.527,1.192a18.452,18.452,0,0,0-5.553,1.877c-1.661,1.173-7.863,7.135-6.45,8.67,1.279,1.389,5.956-4.41,5.956-4.41s-5.236,5.435-3.388,6.824,6.261-5.866,6.261-5.866-5.256,5.706-3.123,6.836c1.61.856,5.978-5.49,5.978-5.49s-4.484,4.935-2.863,5.884c1.789,1.051,6.187-4.555,6.187-4.555,4.524,1.724,7.383.7,9.329-.279C95.627,55.444,90.349,45,90.349,45",
    transform: "translate(72.965 46.496)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275811",
    "data-name": "Path 275811",
    d: "M77.151,47.623c-.638.616-1.289,1.236-1.871,1.905s-1.139,1.362-1.655,2.084a15.075,15.075,0,0,0-1.741,3,32.612,32.612,0,0,1,3.587-4.931c.579-.669,1.126-1.368,1.706-2.039.014-.016-.012-.035-.026-.02",
    transform: "translate(74.28 49.204)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275812",
    "data-name": "Path 275812",
    d: "M77.922,48.632c-.781.821-1.586,1.608-2.332,2.466s-1.368,1.726-2.05,2.627c-.053.069,0,.075.057.008.718-.874,1.446-1.627,2.172-2.491s1.419-1.759,2.174-2.595c.012-.012-.008-.028-.02-.016",
    transform: "translate(75.97 50.248)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275813",
    "data-name": "Path 275813",
    d: "M78.551,49.315a25.272,25.272,0,0,0-3.276,4.044c-.049.071.022.069.075,0,1.065-1.364,1.889-2.444,3.243-4,.02-.022-.016-.067-.043-.043",
    transform: "translate(77.768 50.951)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275814",
    "data-name": "Path 275814",
    d: "M80.115,56.467l9.272,11.472s13.416-3.074,15.325-7.651-4.561-17.44-8.137-22.765-5.842-5.2-5.425.909c.374,5.468,2.4,14.254,2.188,14.555s-13.223,3.481-13.223,3.481",
    transform: "translate(82.786 34.804)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275815",
    "data-name": "Path 275815",
    d: "M81.906,44.8c1.444,1.549,2.818,3.17,4.154,4.813.657.805,1.314,1.614,1.938,2.444.651.864,1.253,1.769,1.907,2.629.03.039-.026.087-.057.049-.679-.836-1.423-1.623-2.121-2.444-.675-.791-1.326-1.6-1.983-2.407-1.34-1.643-2.676-3.294-3.957-4.982a.078.078,0,0,1,.118-.1",
    transform: "translate(84.497 46.263)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275816",
    "data-name": "Path 275816",
    d: "M80.121,51.2c1.035-.083,13.341-3.239,13.355-3.243s-.6-3.908-.728-4.644q-.393-2.257-.882-4.5c0-.033-.065-.031-.061,0,.071.909.173,1.82.293,2.723-.136-.392-.285-.787-.455-1.167-.014-.033-.067-.01-.057.022.2.767.437,1.529.671,2.285.033.2.051.4.083.6q.186,1.132.4,2.259c.073.368.356,1.8.423,2.188-1.635.321-12.109,3.026-13.058,3.392-.035.014-.022.081.016.077",
    transform: "translate(82.754 40.08)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275817",
    "data-name": "Path 275817",
    d: "M92.536,46.8a3.736,3.736,0,0,1-.643.986c-.037.033.01.043.055.01a1.843,1.843,0,0,0,.606-.97c0-.024-.006-.049-.018-.026",
    transform: "translate(94.944 48.351)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275818",
    "data-name": "Path 275818",
    d: "M88.94,37.7c-.073.466-2.033,3.607-4.136,3.668-.685.018-.954-3.713-.954-3.713l-.081-.272-1.157-3.794,4.313-3.253.626-.433s.248,1.057.543,2.379q.021.092.043.189c.018.073.037.144.051.213.047.2.094.4.136.6.033.153.065.3.094.464s.063.319.1.482A25.439,25.439,0,0,1,88.94,37.7",
    transform: "translate(85.366 30.902)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275819",
    "data-name": "Path 275819",
    d: "M88.094,32.287a7.96,7.96,0,0,1-4.325,5.1l-1.157-3.794,4.313-3.253.626-.435s.248,1.059.543,2.381",
    transform: "translate(85.366 30.902)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275820",
    "data-name": "Path 275820",
    d: "M79.923,32.579c-.868,6.907,3.17,8.207,4.66,8.392,1.352.169,5.976.571,7.554-6.21S90.78,25.4,87.707,24.846s-6.915.826-7.784,7.733",
    transform: "translate(82.463 25.561)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275821",
    "data-name": "Path 275821",
    d: "M80.7,28.055c.163,0,.317-.026.482-.041a.8.8,0,0,0,.484-.136.251.251,0,0,0,.035-.3.621.621,0,0,0-.588-.218.918.918,0,0,0-.6.25.266.266,0,0,0,.191.447",
    transform: "translate(83.11 28.266)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275822",
    "data-name": "Path 275822",
    d: "M83.282,28.42a4.491,4.491,0,0,1-.457-.157.786.786,0,0,1-.437-.25.249.249,0,0,1,.039-.3.614.614,0,0,1,.622-.069.908.908,0,0,1,.527.388.266.266,0,0,1-.293.388",
    transform: "translate(85.099 28.511)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275823",
    "data-name": "Path 275823",
    d: "M82.243,28.806c.006-.018.035.028.031.047-.085.47-.1,1.021.3,1.24.012.008.006.03-.008.026-.51-.15-.48-.882-.325-1.314",
    transform: "translate(84.882 29.761)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275824",
    "data-name": "Path 275824",
    d: "M82.721,28.592c.767.053.6,1.584-.108,1.535s-.535-1.58.108-1.535",
    transform: "translate(84.898 29.544)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275825",
    "data-name": "Path 275825",
    d: "M82.628,28.654c.124.1.24.268.4.3.185.039.342-.106.48-.248.016-.014.026,0,.024.02-.026.295-.171.584-.49.594-.291.008-.47-.272-.51-.575-.008-.057.047-.132.1-.091",
    transform: "translate(85.281 29.596)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275826",
    "data-name": "Path 275826",
    d: "M81.233,28.609c0-.018-.039.018-.041.039-.033.476-.148,1.015-.594,1.131-.014,0-.014.026,0,.026.531-.022.679-.74.632-1.2",
    transform: "translate(83.275 29.556)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275827",
    "data-name": "Path 275827",
    d: "M81.075,28.346c-.758-.134-.97,1.391-.268,1.515s.9-1.4.268-1.515",
    transform: "translate(83.058 29.282)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275828",
    "data-name": "Path 275828",
    d: "M80.97,28.467c-.132.065-.27.2-.417.183-.169-.012-.268-.193-.354-.366-.008-.018-.022-.008-.024.012-.049.291,0,.608.277.7.248.085.472-.138.582-.419.02-.053-.01-.14-.063-.114",
    transform: "translate(82.832 29.216)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275829",
    "data-name": "Path 275829",
    d: "M82.452,30.669c-.12.1-.244.25-.417.254a1.239,1.239,0,0,1-.5-.15c-.016-.006-.033.008-.022.022a.641.641,0,0,0,.588.3.511.511,0,0,0,.4-.4c.008-.026-.026-.039-.045-.024",
    transform: "translate(84.223 31.685)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275830",
    "data-name": "Path 275830",
    d: "M81.508,32.042s-.181.7-.222,1.029c0,.033.075.057.187.075l.014,0a1.593,1.593,0,0,0,1.61-.409c.026-.028-.012-.069-.045-.051a2.409,2.409,0,0,1-1.5.242c-.012-.1.35-1.181.3-1.192a3,3,0,0,0-.779.081c.338-1.46.9-2.853,1.218-4.313a.045.045,0,0,0-.083-.033A24.21,24.21,0,0,0,80.7,32.064c-.049.187.667.018.807-.022",
    transform: "translate(83.389 28.366)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275831",
    "data-name": "Path 275831",
    d: "M81.122,30.386a1.906,1.906,0,0,0,.657.7.855.855,0,0,0,.506.11c.382-.039.445-.376.423-.677a2.014,2.014,0,0,0-.1-.468,2.455,2.455,0,0,1-1.488.34",
    transform: "translate(83.827 31.047)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275832",
    "data-name": "Path 275832",
    d: "M81.446,30.843a.845.845,0,0,0,.5.11c.384-.039.445-.376.423-.675a.874.874,0,0,0-.925.565",
    transform: "translate(84.161 31.285)",
    fill: "#ffe7cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275833",
    "data-name": "Path 275833",
    d: "M91.652,34.715c-1.3.2-1.7-2.778-1.7-2.778s-5.563-.813-6.137-5.315A7.642,7.642,0,0,1,80.06,30.89s.079-4.953,3.979-6c0,0,4.827-1.883,7.651,1.917s.832,7.782-.039,7.912",
    transform: "translate(82.729 25.233)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275834",
    "data-name": "Path 275834",
    d: "M81.9,25.34a4.9,4.9,0,0,0,.295,2.054,5.111,5.111,0,0,0,1.088,1.8,4.641,4.641,0,0,0,.382.366l.2.177c.069.053.142.1.213.152.146.1.289.2.439.3s.311.161.468.238c.079.039.157.081.236.116l.246.087.492.177c.338.085.677.153,1.015.216-.321-.132-.649-.228-.964-.36l-.464-.213-.232-.106c-.073-.041-.144-.087-.218-.13-.144-.087-.289-.175-.435-.258s-.268-.2-.4-.3l-.2-.15-.183-.173a4.153,4.153,0,0,1-.358-.35,5.849,5.849,0,0,1-1.094-1.673A6.645,6.645,0,0,1,81.9,25.34",
    transform: "translate(84.617 26.184)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275835",
    "data-name": "Path 275835",
    d: "M85.53,30.38s1.6-2.113,2.566-1.533-.3,3.682-1.472,4.069a1.176,1.176,0,0,1-1.551-.693Z",
    transform: "translate(87.908 29.704)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275836",
    "data-name": "Path 275836",
    d: "M87.389,29.229a.016.016,0,0,1,0,.031,2.981,2.981,0,0,0-1.608,1.8.651.651,0,0,1,.98-.14c.02.016,0,.049-.024.043a.725.725,0,0,0-.805.222,3.475,3.475,0,0,0-.407.63c-.041.071-.171.026-.14-.055l.008-.02c.018-1.033.878-2.45,1.993-2.511",
    transform: "translate(88.231 30.203)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275837",
    "data-name": "Path 275837",
    d: "M83.724,33.768l1.037,3.2,4.134-3.674L89.9,34.628s-4.2,6-4.211,5.712l-1.1-2.769-1.978,1.741.47-4.673Z",
    transform: "translate(85.371 34.399)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275838",
    "data-name": "Path 275838",
    d: "M82.78,36.314c.1-.769.185-1.545.325-2.31,0-.026.047-.037.053,0a42.915,42.915,0,0,1-.352,4.4l.008-.008c.083-.075,1.828-1.525,1.842-1.5.248.443,1.057,2.46,1.108,2.643.667-.954,3.471-4.7,4.242-5.588a.027.027,0,0,1,.045.031c-.6,1.013-4.229,5.958-4.276,5.939A30.092,30.092,0,0,1,84.628,37a20.777,20.777,0,0,1-2.072,1.856,24.139,24.139,0,0,1,.224-2.54",
    transform: "translate(85.309 35.074)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275839",
    "data-name": "Path 275839",
    d: "M9,70.777a34.528,34.528,0,0,1,.8-5.626A12.511,12.511,0,0,1,11.807,60.4a6.026,6.026,0,0,1,3.941-2.456,5.506,5.506,0,0,1,4.146,1.472,20,20,0,0,1,3.554,4.345,53.54,53.54,0,0,1,3.07,5.372c.03.061-.063.112-.094.051a33.756,33.756,0,0,0-2.745-4.5,28.35,28.35,0,0,0-3.162-3.827,6.224,6.224,0,0,0-3.941-2.05A4.838,4.838,0,0,0,12.722,60.8a11.836,11.836,0,0,0-1.942,4.561,33.964,33.964,0,0,0-.793,5.356c-.3,3.707-.382,7.436-.466,11.151q-.073,3.157-.1,6.312-.015,1.6-.026,3.2a19.491,19.491,0,0,1-.124,3.083c-.035.207-.372.187-.407-.01a18.2,18.2,0,0,1-.142-2.922q-.021-1.516-.037-3.03c-.016-1.964-.026-3.928-.02-5.893.01-3.941.059-7.9.327-11.832",
    transform: "translate(8.957 59.848)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275840",
    "data-name": "Path 275840",
    d: "M11.838,68.684a8.6,8.6,0,0,1,1.147-3.227c1.074-1.458,2.233-.823,1.161.791a9.668,9.668,0,0,0-1.507,3.985,15.283,15.283,0,0,0,3.981,3.845,17.142,17.142,0,0,1-.181-3.985c.419-3.182,2.344-3,1.869-.476a21.91,21.91,0,0,0-.435,5.116A10.789,10.789,0,0,0,20.2,75.872c-.126-.368-.258-.811-.4-1.348-.773-2.855,1.131-3.745,1.192-2.139a22.5,22.5,0,0,0,.74,4.048c1.043.352,1.909.59,2.438.777a8.916,8.916,0,0,1,3.571,2.438A11.236,11.236,0,0,0,30.166,76.5c-.665-.573-1.716-1.423-3.176-2.454-2.737-1.932-1.785-4.37.386-2.855a12.5,12.5,0,0,1,3.329,4.164,16.9,16.9,0,0,0,1.242-5.7c-2.149-2.017-7.464-4.829-5.862-4.829,1.442,0,4.667,2.115,5.85,2.93a14.772,14.772,0,0,0-.181-1.655c-2.025-1.328-8.6-3.392-7.554-3.985,1.151-.651,5.74,1.474,7.127,2.145a8.29,8.29,0,0,0-1.216-2.517c-2.8-3.743-7.839-5.035-10.039-4.321-1.558.506-1.1,4.455-1.438,4.321-6.255-2.517-9.1-.738-6.8,6.936m15.331-.433c.443-.537,2.5,1.041,1.9,1.9s-2.477-1.216-1.9-1.9M16.443,64.882c.541.344-.258,2.338-1.09,1.734-.71-.514.547-2.082,1.09-1.734",
    transform: "translate(11.413 59.147)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87492",
    "data-name": "Group 87492",
    transform: "translate(22.458 116.386)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87491",
    "data-name": "Group 87491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87490",
    "data-name": "Group 87490",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275841",
    "data-name": "Path 275841",
    d: "M11.838,68.684a8.6,8.6,0,0,1,1.147-3.227c1.074-1.458,2.233-.823,1.161.791a9.668,9.668,0,0,0-1.507,3.985,15.283,15.283,0,0,0,3.981,3.845,17.142,17.142,0,0,1-.181-3.985c.419-3.182,2.344-3,1.869-.476a21.91,21.91,0,0,0-.435,5.116A10.789,10.789,0,0,0,20.2,75.872c-.126-.368-.258-.811-.4-1.348-.773-2.855,1.131-3.745,1.192-2.139a22.5,22.5,0,0,0,.74,4.048c1.043.352,1.909.59,2.438.777a8.916,8.916,0,0,1,3.571,2.438A11.236,11.236,0,0,0,30.166,76.5c-.665-.573-1.716-1.423-3.176-2.454-2.737-1.932-1.785-4.37.386-2.855a12.5,12.5,0,0,1,3.329,4.164,16.9,16.9,0,0,0,1.242-5.7c-2.149-2.017-7.464-4.829-5.862-4.829,1.442,0,4.667,2.115,5.85,2.93a14.772,14.772,0,0,0-.181-1.655c-2.025-1.328-8.6-3.392-7.554-3.985,1.151-.651,5.74,1.474,7.127,2.145a8.29,8.29,0,0,0-1.216-2.517c-2.8-3.743-7.839-5.035-10.039-4.321-1.558.506-1.1,4.455-1.438,4.321-6.255-2.517-9.1-.738-6.8,6.936m15.331-.433c.443-.537,2.5,1.041,1.9,1.9s-2.477-1.216-1.9-1.9M16.443,64.882c.541.344-.258,2.338-1.09,1.734-.71-.514.547-2.082,1.09-1.734",
    transform: "translate(-11.045 -57.239)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275842",
    "data-name": "Path 275842",
    d: "M14.886,63.1c.283-.557.577-1.112.9-1.649a9.659,9.659,0,0,1,1.033-1.5c-.089-.11-.175-.222-.266-.329-.037-.045.026-.106.065-.063.106.12.205.242.307.364a.1.1,0,0,1,.043.051c.386.464.75.941,1.1,1.427a16.712,16.712,0,0,1,1.818.527c.612.205,1.22.419,1.816.669.063.026.033.13-.028.1-.592-.26-1.192-.514-1.8-.72-.58-.2-1.167-.348-1.755-.512.191.268.378.541.557.817A21.373,21.373,0,0,1,21.881,63.6c1.086.516,2.131,1.114,3.17,1.716A.053.053,0,0,1,25,65.4a35.292,35.292,0,0,0-3.154-1.631c-1.007-.472-2.048-.858-3.062-1.307,2.554,3.987,4.087,8.587,6.137,12.845.028.061-.069.114-.1.051-.624-1.492-1.344-2.948-2.025-4.418-.612-1.318-1.208-2.643-1.82-3.963-.179-.386-.364-.771-.551-1.155a57.887,57.887,0,0,0,.415,6.4.052.052,0,1,1-.1.012c-.148-2.275-.549-4.516-.533-6.8,0-.012.01-.018.012-.028-.433-.87-.895-1.728-1.393-2.564a29.9,29.9,0,0,0-2.131,6.155c-.012.065-.12.037-.1-.031a30.271,30.271,0,0,1,2.141-6.275,24.224,24.224,0,0,0-1.8-2.593c-.285.531-.649,1.031-.972,1.537s-.624.99-.915,1.5a21.879,21.879,0,0,0-1.6,3.375c-.022.065-.128.033-.1-.031.488-1.133.982-2.273,1.539-3.375",
    transform: "translate(13.788 61.534)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275843",
    "data-name": "Path 275843",
    d: "M4.209,65.611c1.639-1.643,3.544-3.8,6.078-3.8,2.444,0,4.244,1.972,5.277,4a20.98,20.98,0,0,1,1.775,6.869,83.2,83.2,0,0,1,.649,8.444c.045,1.568.039,3.135,0,4.7a31.15,31.15,0,0,1-.36,4.748c-.045.252-.451.262-.468-.01-.073-1.322-.02-2.647-.012-3.969q.009-1.949-.061-3.9c-.1-2.631-.289-5.256-.6-7.871a38.1,38.1,0,0,0-1.167-6.838C14.7,66,13.55,63.726,11.533,62.852c-2.753-1.192-5.441.986-7.243,2.826-.047.049-.13-.018-.081-.067",
    transform: "translate(4.334 63.875)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275844",
    "data-name": "Path 275844",
    d: "M.1,71.211v0c.012.336.033.669.055.992A5.926,5.926,0,0,1,2.838,71.1c2.326-.248,2.178,1.521.624,1.6a8.863,8.863,0,0,0-3.192.638,19.806,19.806,0,0,0,1.352,5.575,45.269,45.269,0,0,0,6.145-.777c-.577-1.232-1.9-2.871-1.224-3,.687-.136,1.407,1.326,1.777,2.891a29.434,29.434,0,0,0,4.471-1.232c-1.023-.885-2.6-1.987-2-2.456s1.861,1.082,2.613,2.21a9.07,9.07,0,0,0,1.932-1.078c-1.379-2.025-4.74-2.438-4.3-3.9.447-1.492,3.583.567,4.994,3.278A8.013,8.013,0,0,0,18,68.607c-1.444-.169-4.221.136-4.02-.9.189-.986,2.208-.84,3.851-.234a5.758,5.758,0,0,0-.964-2.285c-1.523-1.954-6.165.531-6.165.531s.5-4.667-1.275-5.474a5.3,5.3,0,0,0-4.63.6,3.885,3.885,0,0,1,2.731,1.108c.63.9-.364,1.385-.994.972a5.053,5.053,0,0,0-2.776-1.34,9.236,9.236,0,0,0-1.675,1.856,9.139,9.139,0,0,0-.49.773,6.366,6.366,0,0,1,5.435.1c2.015,1,.891,3.091-.842,2.277-1.714-.8-3.383-1.61-5.22-1.151A13.034,13.034,0,0,0,.08,70.646a9.12,9.12,0,0,1,2.983-1.431c2-.525,2.607.671.407.895A8.819,8.819,0,0,0,.1,71.211M2.533,68c-.138-.649,1.281-.836,1.517-.309.2.449-1.383.958-1.517.309m12.145,3.591c.132-.354,1.082.049,1,.49-.118.59-1.126-.136-1-.49M7.972,73.865c.691-.277,1.773,1.444,1.019,1.838s-1.584-1.61-1.019-1.838",
    transform: "translate(0.082 61.947)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87495",
    "data-name": "Group 87495",
    transform: "translate(0.163 121.897)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87494",
    "data-name": "Group 87494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87493",
    "data-name": "Group 87493",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275845",
    "data-name": "Path 275845",
    d: "M.1,71.211v0c.012.336.033.669.055.992A5.926,5.926,0,0,1,2.838,71.1c2.326-.248,2.178,1.521.624,1.6a8.863,8.863,0,0,0-3.192.638,19.806,19.806,0,0,0,1.352,5.575,45.269,45.269,0,0,0,6.145-.777c-.577-1.232-1.9-2.871-1.224-3,.687-.136,1.407,1.326,1.777,2.891a29.434,29.434,0,0,0,4.471-1.232c-1.023-.885-2.6-1.987-2-2.456s1.861,1.082,2.613,2.21a9.07,9.07,0,0,0,1.932-1.078c-1.379-2.025-4.74-2.438-4.3-3.9.447-1.492,3.583.567,4.994,3.278A8.013,8.013,0,0,0,18,68.607c-1.444-.169-4.221.136-4.02-.9.189-.986,2.208-.84,3.851-.234a5.758,5.758,0,0,0-.964-2.285c-1.523-1.954-6.165.531-6.165.531s.5-4.667-1.275-5.474a5.3,5.3,0,0,0-4.63.6,3.885,3.885,0,0,1,2.731,1.108c.63.9-.364,1.385-.994.972a5.053,5.053,0,0,0-2.776-1.34,9.236,9.236,0,0,0-1.675,1.856,9.139,9.139,0,0,0-.49.773,6.366,6.366,0,0,1,5.435.1c2.015,1,.891,3.091-.842,2.277-1.714-.8-3.383-1.61-5.22-1.151A13.034,13.034,0,0,0,.08,70.646a9.12,9.12,0,0,1,2.983-1.431c2-.525,2.607.671.407.895A8.819,8.819,0,0,0,.1,71.211M2.533,68c-.138-.649,1.281-.836,1.517-.309.2.449-1.383.958-1.517.309m12.145,3.591c.132-.354,1.082.049,1,.49-.118.59-1.126-.136-1-.49M7.972,73.865c.691-.277,1.773,1.444,1.019,1.838s-1.584-1.61-1.019-1.838",
    transform: "translate(-0.08 -59.95)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275846",
    "data-name": "Path 275846",
    d: "M.974,75.536c1.043-1.745,2.074-3.5,3.17-5.209q.766-1.2,1.6-2.346c-.083-.016-.167-.041-.248-.059q-.207-.043-.415-.079c-.321-.055-.645-.1-.968-.134-.3-.031-.61-.049-.915-.051a4.511,4.511,0,0,0-.98.051c-.039.008-.045-.053-.008-.053.327.014.661-.028.986-.033s.634,0,.952.022c.3.016.592.047.887.091.163.024.325.053.486.085a2.92,2.92,0,0,1,.295.061q.845-1.165,1.757-2.283a20.886,20.886,0,0,0-5.71-1.822c-.035-.006-.022-.057.012-.053a19.367,19.367,0,0,1,5.793,1.759c.333-.411.669-.817,1.007-1.224.376-.453.781-.9,1.122-1.379a.027.027,0,1,1,.043.033,19.3,19.3,0,0,0-1.324,1.621h.008a20.141,20.141,0,0,1,2.123,1.706q1.043.921,2.029,1.905c.024.022-.012.061-.037.037-.651-.645-1.324-1.263-2.029-1.848s-1.446-1.124-2.155-1.7l-.006-.01c-.161.214-.323.429-.486.638l-.244.321L7.7,65.6q-.406.531-.809,1.063a8.512,8.512,0,0,1,.805,1.454c.234.492.437,1,.624,1.513a22.111,22.111,0,0,1,.87,3.268c.006.033-.045.049-.051.014a19.115,19.115,0,0,0-.95-3.2c-.2-.535-.433-1.053-.671-1.572-.218-.472-.48-.925-.683-1.4q-.351.467-.7.937c-.065.091-.13.185-.2.279.01.02,0,.047-.022.047H5.909c-.716,1-1.4,2.025-2.062,3.06a.97.97,0,0,1,.091.228c.043.126.081.252.12.38a7.82,7.82,0,0,1,.181.777c.045.246.079.494.1.742a7.228,7.228,0,0,0,.063.844c.01.043-.059.045-.051,0a2.717,2.717,0,0,0-.059-.789c-.037-.268-.087-.537-.148-.8-.057-.24-.122-.478-.193-.714-.035-.118-.073-.236-.114-.352-.022-.063-.051-.128-.073-.193-.309.486-.618.976-.921,1.468q-.9,1.461-1.793,2.928c-.031.051-.11.008-.079-.043",
    transform: "translate(1 64.963)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275847",
    "data-name": "Path 275847",
    d: "M8.883,84.33c.026-.988.183-1.985.291-2.967s.218-1.974.323-2.963a44.978,44.978,0,0,1,.765-5.716,8.317,8.317,0,0,1,2.326-4.274,3.8,3.8,0,0,1,2.279-1.088,3.929,3.929,0,0,1,2.422.746,8.442,8.442,0,0,1,2.035,2.145,20.85,20.85,0,0,1,1.588,2.578c.018.035-.035.055-.053.024a13.21,13.21,0,0,0-3.436-3.849,4.047,4.047,0,0,0-2.166-.9,2.933,2.933,0,0,0-2.1.838,7.884,7.884,0,0,0-2.218,3.922,40.187,40.187,0,0,0-.858,5.281c-.14,1.045-.272,2.092-.411,3.137s-.224,2.109-.445,3.133a.174.174,0,0,1-.344-.047",
    transform: "translate(9.179 69.562)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275848",
    "data-name": "Path 275848",
    d: "M11.915,76.9a5.478,5.478,0,0,0,1.076,1.1,6.722,6.722,0,0,1,.128-3.591c.754-1.417,1.651-.71,1.2.523a10.036,10.036,0,0,0-.728,3.493,15.161,15.161,0,0,0,3.284,1.547,5.5,5.5,0,0,1-.108-1.69c.15-1.515,1.309-1.486,1.009.089a9.608,9.608,0,0,0-.159,1.85,34.186,34.186,0,0,0,5.118,1.155,14.938,14.938,0,0,0,2.117-3.77c-1.232-.309-3.729-.38-3.676-1.261.071-1.185,2.489-.272,3.9.588a9.465,9.465,0,0,0,.427-3.19,15.812,15.812,0,0,0-3.4-.563c-2.54-.22-2.414-1.659-.575-1.627a10.073,10.073,0,0,1,3.89,1.289c-.531-3.455-3.164-5.667-5.277-5.752-3.552-.142-2.273,4.276-2.273,4.276a9.4,9.4,0,0,0-4.677-1.649c-2.267.049-3.707,3.806-1.279,7.184M21.4,70.51c-.077-.5,1.507-.618,1.59.02.094.716-1.509.484-1.59-.02m2.55,5.183c-.033-.325.653-.382.807.028.1.266-.779.293-.807-.028m-8.526.3c.535.075.84,1.989-.081,1.952-.7-.031-.372-2.017.081-1.952",
    transform: "translate(11.009 69.318)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87498",
    "data-name": "Group 87498",
    transform: "translate(21.664 136.401)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87497",
    "data-name": "Group 87497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87496",
    "data-name": "Group 87496",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275849",
    "data-name": "Path 275849",
    d: "M11.915,76.9a5.478,5.478,0,0,0,1.076,1.1,6.722,6.722,0,0,1,.128-3.591c.754-1.417,1.651-.71,1.2.523a10.036,10.036,0,0,0-.728,3.493,15.161,15.161,0,0,0,3.284,1.547,5.5,5.5,0,0,1-.108-1.69c.15-1.515,1.309-1.486,1.009.089a9.608,9.608,0,0,0-.159,1.85,34.186,34.186,0,0,0,5.118,1.155,14.938,14.938,0,0,0,2.117-3.77c-1.232-.309-3.729-.38-3.676-1.261.071-1.185,2.489-.272,3.9.588a9.465,9.465,0,0,0,.427-3.19,15.812,15.812,0,0,0-3.4-.563c-2.54-.22-2.414-1.659-.575-1.627a10.073,10.073,0,0,1,3.89,1.289c-.531-3.455-3.164-5.667-5.277-5.752-3.552-.142-2.273,4.276-2.273,4.276a9.4,9.4,0,0,0-4.677-1.649c-2.267.049-3.707,3.806-1.279,7.184M21.4,70.51c-.077-.5,1.507-.618,1.59.02.094.716-1.509.484-1.59-.02m2.55,5.183c-.033-.325.653-.382.807.028.1.266-.779.293-.807-.028m-8.526.3c.535.075.84,1.989-.081,1.952-.7-.031-.372-2.017.081-1.952",
    transform: "translate(-10.655 -67.083)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275850",
    "data-name": "Path 275850",
    d: "M13.365,72.879c.087-.238.167-.48.242-.724-.069.246-.13.494-.177.742a.034.034,0,1,1-.065-.018",
    transform: "translate(13.808 74.56)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275851",
    "data-name": "Path 275851",
    d: "M14.153,72.782c.167-.49.354-.976.543-1.456.1-.258.207-.512.321-.767a3.123,3.123,0,0,1,.315-.64,5.01,5.01,0,0,1-.287-.62.019.019,0,0,1,.033-.018,7.49,7.49,0,0,1,.691,1.074c.1.167.193.338.291.506a5.331,5.331,0,0,1,.6.091c.214.041.425.083.636.13s.423.1.634.148.417.118.628.15c.049.008.028.085-.018.067a3.922,3.922,0,0,0-.663-.173c-.205-.045-.409-.081-.616-.11s-.413-.055-.62-.075c-.155-.016-.313-.024-.47-.039.085.148.173.295.256.445l.037.073a1.98,1.98,0,0,1,.51.059c.183.033.366.069.549.108.37.083.738.171,1.1.272.769.214,1.527.46,2.285.708.043.014.016.077-.026.063a22.449,22.449,0,0,0-2.3-.636c-.364-.081-.726-.165-1.09-.242-.183-.037-.366-.077-.549-.116a3.733,3.733,0,0,1-.423-.094c.39.722.758,1.456,1.1,2.2.736,1.629,1.356,3.308,1.989,4.98.016.041-.049.069-.063.026a45.664,45.664,0,0,0-2.117-4.868c-.14-.289-.287-.575-.431-.864-.012.059-.026.116-.037.177-.037.2-.071.394-.106.592-.065.4-.134.793-.193,1.19a14.047,14.047,0,0,0-.287,2.468c0,.051-.075.049-.067,0,.063-.394.063-.805.087-1.2.026-.417.057-.832.106-1.244s.1-.8.163-1.194c.033-.2.067-.4.1-.594a1.164,1.164,0,0,1,.112-.429c-.207-.419-.413-.836-.624-1.253q-.3-.586-.6-1.167c-.085-.163-.179-.329-.27-.5a4.565,4.565,0,0,1-.236.6c-.089.224-.181.447-.274.673-.2.494-.392.994-.582,1.5-.268.71-.565,1.438-.787,2.176.218-.724.4-1.464.645-2.18",
    transform: "translate(13.958 71.583)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275852",
    "data-name": "Path 275852",
    d: "M13.483,72.243c.016-.057.035-.114.051-.171-.016.057-.033.114-.051.171",
    transform: "translate(13.933 74.474)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275853",
    "data-name": "Path 275853",
    d: "M5.963,74.739l.25,5.287.643,13.623H20.912l.643-13.623.25-5.287Z",
    transform: "translate(6.162 77.23)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275854",
    "data-name": "Path 275854",
    d: "M5.963,74.739l.25,5.287H21.555l.25-5.287Z",
    transform: "translate(6.162 77.23)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25364",
    "data-name": "Rectangle 25364",
    width: 17.841,
    height: 4.274,
    transform: "translate(11.126 149.833)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25365",
    "data-name": "Rectangle 25365",
    width: 2.468,
    height: 2.237,
    transform: "translate(23.469 170.88)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25366",
    "data-name": "Rectangle 25366",
    width: 2.468,
    height: 1.118,
    transform: "translate(23.467 170.88)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25367",
    "data-name": "Rectangle 25367",
    width: 2.466,
    height: 2.237,
    transform: "translate(14.156 170.88)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25368",
    "data-name": "Rectangle 25368",
    width: 2.466,
    height: 1.118,
    transform: "translate(14.156 170.88)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275855",
    "data-name": "Path 275855",
    d: "M86.475,30.725a5.556,5.556,0,0,0,.952-3.074c0-3.894-4.276-7.052-9.549-7.052s-9.545,3.158-9.545,7.052S72.606,34.7,77.879,34.7a11.471,11.471,0,0,0,6.586-1.95l3.29.836Z",
    transform: "translate(70.612 21.285)",
    fill: "#fffdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275856",
    "data-name": "Path 275856",
    d: "M86.571,30.807c2.6-3.837-.811-8.335-4.725-9.366-3.841-1.228-8.485-.58-11.4,2.263-3.357,3.135-1.539,8.089,2.367,9.758A12.067,12.067,0,0,0,84.5,32.749l.043-.028.045.012,3.276.889-.059.069Zm0,0L87.9,33.65l.043.094-.1-.024-3.3-.785c-3,2.312-8.209,2.627-11.881.85-4.162-1.743-6.151-7.05-2.507-10.376,3.113-2.954,7.863-3.53,11.787-2.237,4.006,1.057,7.42,5.83,4.636,9.636",
    transform: "translate(70.516 21.203)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275857",
    "data-name": "Path 275857",
    d: "M72.346,24.57a.99.99,0,1,1-.99-.99.99.99,0,0,1,.99.99",
    transform: "translate(72.712 24.365)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275858",
    "data-name": "Path 275858",
    d: "M74.522,24.57a.99.99,0,1,1-.99-.99.99.99,0,0,1,.99.99",
    transform: "translate(74.961 24.365)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275859",
    "data-name": "Path 275859",
    d: "M76.7,24.57a.99.99,0,1,1-.99-.99.99.99,0,0,1,.99.99",
    transform: "translate(77.208 24.365)",
    fill: "#1a2e35"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11To1Session);
export default __webpack_public_path__ + "static/media/1_1to1_Session.bf0644dc093ffb92ebe48886302f14e7.svg";
export { ForwardRef as ReactComponent };